import { Product } from '../types';
import { DOCS_ORIGIN } from '../config/site';

/**
 * Khmer translations of src/assets/products.ts, mirrored product-by-product.
 * Accessors in products.ts fall back to the English record whenever a slug is
 * missing here, so partial coverage degrades gracefully.
 */
export const ProductsKm: Product[] = [
  {
    id: 1,
    slug: 'hrms',
    name: 'ការគ្រប់គ្រងធនធានមនុស្ស',
    shortName: 'HRMS',
    navLabel: 'ការគ្រប់គ្រងធនធានមនុស្ស',
    tagline: 'ជ្រើសរើសបុគ្គលិក វត្តមាន បើកប្រាក់ខែ និងអភិវឌ្ឍបុគ្គលិកក្នុងប្រព័ន្ធតែមួយ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/hrms/`,
    description:
      'AKAS HRMS គឺជាប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្សពេញលេញ ពីការជ្រើសរើសរហូតដល់ចូលនិវត្តន៍។ បុគ្គលិកស្នើសុំការឈប់សម្រាក ម៉ោងបន្ថែម (OT) ការបណ្តុះបណ្តាល សំណើជ្រើសរើសបុគ្គលិក និងលាលែងពីការងារ តាម Dashboard សេវាកម្មបុគ្គលិកដោយខ្លួនឯង។ ផ្នែកធនធានមនុស្ស គ្រប់គ្រងការជ្រើសរើស ការគ្រប់គ្រងបុគ្គលិក វត្តមាន ការឈប់សម្រាក ការវាយតម្លៃការងារ ការគណនាប្រាក់ខែ (រួមទាំងពន្ធលើប្រាក់ខែ NSSF និងអាយុការ) និងការបណ្តុះបណ្តាល — ជាមួយលំហូរការងារអនុម័ត អេក្រង់ពហុភាសា និងកំណត់ត្រាទាំងអស់នៅក្នុងមូលដ្ឋានទិន្នន័យអ៊ិនគ្រីបតែមួយ។',
    images: [
      '/images/products/hr-db-1.png',
      '/images/products/hr-db-2.png',
      '/images/products/hr-employee-list.png',
      '/images/products/hr-employee-form.png',
      '/images/products/hr-employment.png',
      '/images/products/hr-employment-history.png',
      '/images/products/hr-leave-request.png',
      '/images/products/hr-mypayslip.png',
      '/images/products/hr-approval-workflow.png',
    ],
    backgroundImage: '/images/backgrounds/hrms.jpg',
    highlights: [
      'សេវាកម្មបុគ្គលិកដោយខ្លួនឯង សម្រាប់ការឈប់សម្រាក OT ស្លឹកប្រាក់ខែ ការបណ្តុះបណ្តាល និងលាលែងពីការងារ',
      'ការគណនាប្រាក់ខែ រួមមានពន្ធលើប្រាក់ខែ (TOS01) NSSF eForm អាយុការ បញ្ជីធនាគារ និងស្លឹកប្រាក់ខែ',
      'វត្តមានពីឧបករណ៍ជីវមាត្រ ការចុះវត្តមាន QR តារាងវេន និង timesheet',
      'លំហូរការងារអនុម័ត ជាមួយការប្រគល់សិទ្ធិអនុម័តជាបណ្តោះអាសន្ន',
    ],
    workflow: {
      title: 'ពីការជ្រើសរើសដល់ចូលនិវត្តន៍',
      path: 'Requisition → Hire → Attendance & leave → Payroll → Review → Separation',
      steps: [
        {
          title: 'ជ្រើសរើសបុគ្គលិក',
          description:
            'បុគ្គលិកដាក់សំណើជ្រើសរើស ហើយទទួលការអនុម័ត។ សំណើក្លាយជាកន្លែងការងារទំនេរ ប្រមូលពាក្យសុំ ជូនដំណឹងបេក្ខជន និងចាត់ចូលការគ្រប់គ្រងបុគ្គលិក។',
        },
        {
          title: 'ចាត់ចូលធ្វើការ',
          description:
            'បង្កើតប្រវត្តិរូប កិច្ចសន្យាការងារ ប្រាក់ខែ ចំនួនថ្ងៃឈប់សម្រាក កាលវិភាគធ្វើការ និងខ្សែរបាយការណ៍។',
        },
        {
          title: 'វត្តមាន និងការឈប់សម្រាក',
          description:
            'កត់ត្រាការចុះវត្តមាន បេសកកម្មការងារខាងក្រៅ និងការចុះ QR ដំណើរការ timesheet និងអនុម័តការឈប់សម្រាកតាមសមតុល្យ និងថ្ងៃឈប់សម្រាកសាធារណៈ។',
        },
        {
          title: 'បើកប្រាក់ខែ និងអភិវឌ្ឍ',
          description:
            'ដំណើរការ OT, Pay Queue និងបញ្ជីការគណនាប្រាក់ខែ។ ធ្វើការវាយតម្លៃការងារ និងបណ្តុះបណ្តាលតាមសេវាកម្មបុគ្គលិកដោយខ្លួនឯង។',
        },
      ],
    },
    capabilities: [
      {
        title: 'Dashboard សេវាកម្មបុគ្គលិកដោយខ្លួនឯង',
        items: [
          'សំណើឈប់សម្រាក លុបចោលការឈប់សម្រាក បញ្ជីឈប់សម្រាករបស់ខ្លួន និងប្រតិទិន',
          'សំណើទូទាត់ OT និងស្លឹកប្រាក់ខែរបស់ខ្លួន',
          'សំណើបណ្តុះបណ្តាល និងការវាយតម្លៃការងារ',
          'សំណើជ្រើសរើសបុគ្គលិក កន្លែងការងារទំនេរ សំណើលាលែងពីការងារ និងការដកស្តុកក្រុមហ៊ុន',
        ],
      },
      {
        title: 'ការគ្រប់គ្រងបុគ្គលិក',
        items: [
          'គ្រប់គ្រងបុគ្គលិក៖ លេខសម្គាល់ អ៊ីមែល ខ្សែរបាយការណ៍ អង្គភាពការងារ ប្រាក់ខែ ចំនួនថ្ងៃឈប់សម្រាក កាលវិភាគ',
          'កិច្ចសន្យាការងារ ការប្តូរតួនាទី/ដំឡើងតំណែង កំហុសវិន័យ ពានរង្វាន់ និងគ្រោះថ្នាក់',
          'ការចាកចេញដោយលាលែងពីការងារ ឬបញ្ឈប់ការងារ ដែលអាចចាប់ផ្តើមពីសេវាកម្មបុគ្គលិកដោយខ្លួនឯង',
        ],
      },
      {
        title: 'ការគណនាប្រាក់ខែ ជាមួយរបាយការណ៍ផ្លូវច្បាប់ក្នុងស្រុក',
        items: [
          'ធាតុប្រាក់ខែ គោលនយោបាយប្រាក់ខែ រយៈពេលប្រាក់ខែ — រួមមានរបៀបពាក់កណ្តាលរយៈពេលសម្រាប់ការគណនាប្រាក់ខែពីរដងក្នុងមួយខែ — ប្រភេទ/គោលនយោបាយ OT ប្រាក់បន្ថែមវេន និងគោលនយោបាយថែទាំកូន',
          'ធាតុប្រាក់ខែគណនាតាមរូបមន្ត ជួរពន្ធលើប្រាក់ខែ តារាងកំណត់ចំណាត់ថ្នាក់ Pay Queue និងបញ្ជីការគណនាប្រាក់ខែ (គណនា ពិនិត្យ អនុម័ត) ជាមួយស្លឹកប្រាក់ខែ',
          'របាយការណ៍ផ្លូវច្បាប់៖ PAY004 NSSF eForm, PAY005 ពន្ធលើប្រាក់ខែ (TOS01), PAY006 ពន្ធលើអត្ថប្រយោជន៍បន្ថែម, PAY009 អាយុការ, PAY010 មូលនិធិចូលនិវត្តន៍ — រួមទាំងបញ្ជីផ្ទេរតាមធនាគារ PAY003/PAY008',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '💻',
        title: 'សេវាកម្មបុគ្គលិកដោយខ្លួនឯងអនឡាញ',
        description:
          'បន្ទាប់ពីចូលប្រព័ន្ធ បុគ្គលិកប្រើ Dashboard → Self Service សម្រាប់សំណើប្រចាំថ្ងៃ៖ ធ្វើបច្ចុប្បន្នភាពប្រវត្តិរូប មើលកាលវិភាគ ស្នើសុំការឈប់សម្រាក ទាមទារ OT ចាប់ផ្តើមការវាយតម្លៃការងារ ស្នើសុំបណ្តុះបណ្តាល ដាក់សំណើជ្រើសរើសបុគ្គលិក ឬលាលែងពីការងារ។ អ្នកគ្រប់គ្រងឃើញសំណើរង់ចាំអនុម័ត។ បុគ្គលិកឃើញសំណើរបស់ខ្លួន ស្លឹកប្រាក់ខែ កន្លែងការងារទំនេរ និងសារ។ Approval Delegation អនុញ្ញាតឱ្យប្រគល់សិទ្ធិអនុម័តជាបណ្តោះអាសន្ន។',
        images: [
          '/images/products/hr-ess-leaverequest.png',
          '/images/products/hr-ess-leavecancel.png',
          '/images/products/hr-ess-myleave.png',
          '/images/products/hr-ess-resignrequest.png',
          '/images/products/hr-ess-jobrequisition.png',
          '/images/products/hr-ess-mypendingrequest.png',
        ],
      },
      {
        icon: '👥',
        title: 'ការជ្រើសរើសបុគ្គលិក',
        description:
          'កំណត់សកម្មភាពជូនដំណឹង បន្ទាប់មកដាក់សំណើជ្រើសរើសបុគ្គលិក (តាមធនធានមនុស្ស ឬសេវាកម្មបុគ្គលិកដោយខ្លួនឯង)។ បន្ទាប់ពីអនុម័ត គ្រប់គ្រងពាក្យសុំតាមកន្លែងការងារទំនេរនោះ។ បេក្ខជនរកមើលកន្លែងទំនេរសាធារណៈ/ផ្ទៃក្នុង និងដាក់ពាក្យអនឡាញ។ ប្រវត្តិរូបបេក្ខជនរក្សា CV ទំនាក់ទំនង និងជំនាញ។ ធនធានមនុស្ស អាចជូនដំណឹងបេក្ខជនដែលបានជ្រើស ឬបដិសេធ តាមលំហូរការងារដែលបានកំណត់ រួមទាំងការញែក resume ដោយជំនួយ AI។',
        images: [
          '/images/products/hr-recruit-jobtitle.png',
          '/images/products/hr-recruit-jobrequisition.png',
          '/images/products/hr-recruit-manage-applicants.png',
          '/images/products/hr-recruit-manage-applicants2.png',
          '/images/products/hr-recruit-notify-applicant.png',
          '/images/products/hr-recruit-notify-custom.png',
        ],
      },
      {
        icon: '👤',
        title: 'ការគ្រប់គ្រងបុគ្គលិក',
        description:
          'គ្រប់គ្រងគណនីបុគ្គលិក៖ លេខសម្គាល់ អ៊ីមែល ខ្សែរបាយការណ៍ ថ្ងៃចូលធ្វើការ អង្គភាពការងារ ប្រាក់ខែ ចំនួនថ្ងៃឈប់សម្រាក និងកាលវិភាគធ្វើការ។ លំហូរការងារគ្របដណ្តប់ការចាត់ចូលធ្វើការ ការប្តូរតួនាទី និងដំឡើងតំណែង ការផ្តល់ធានារ៉ាប់រង ពានរង្វាន់ កំហុសវិន័យ គ្រោះថ្នាក់ និងការបញ្ឈប់ការងារ។ បោះពុម្ពកិច្ចសន្យាការងារពីកំណត់ត្រាការងារ។',
        images: [
          '/images/products/hr-employee-list.png',
          '/images/products/hr-employee-form.png',
          '/images/products/hr-employment.png',
          '/images/products/hr-employment-history.png',
          '/images/products/hr-emp-printcontract.png',
        ],
      },
      {
        icon: '📅',
        title: 'ការឈប់សម្រាក និងវត្តមាន',
        description:
          'ការឈប់សម្រាកគ្របដណ្តប់ថ្ងៃឈប់សម្រាកសាធារណៈ ប្រភេទច្បាប់ វេនធ្វើការ បញ្ជីឈប់សម្រាក ការគណនាសមតុល្យ ប្រតិទិន និងរបាយការណ៍។ វត្តមានគ្របដណ្តប់គោលនយោបាយ (យឺត/ចេញមុន/អវត្តមាន) ឧបករណ៍ជីវមាត្រ ទីតាំង QR បេសកកម្មការងារខាងក្រៅ កំណត់ត្រាចុះវត្តមានដើម តារាងវេន ការដំណើរការទៅ timesheet និងរបាយការណ៍វត្តមានខុសពីធម្មតា។',
        images: [
          '/images/products/hr-leave-holiday.png',
          '/images/products/hr-leave-leavetype.png',
          '/images/products/hr-leave-workshift.png',
          '/images/products/hr-leave-records.png',
          '/images/products/hr-leave-balance.png',
          '/images/products/hr-leave-report.png',
        ],
      },
      {
        icon: '📊',
        title: 'ការគ្រប់គ្រងសមិទ្ធផលការងារ',
        description:
          'កំណត់ KPI និងក្រុមកំណត់ចំណាត់ថ្នាក់ បន្ទាប់មកបង្កើតទម្រង់វាយតម្លៃមានទម្ងន់ ជាមួយអ្នកវាយតម្លៃខ្លួនឯង និងអ្នកគ្រប់គ្រង។ បុគ្គលិកចាប់ផ្តើមការវាយតម្លៃពីសេវាកម្មបុគ្គលិកដោយខ្លួនឯង។ ធនធានមនុស្ស និងអ្នកគ្រប់គ្រងតាមដាន អនុម័ត និងបោះពុម្ព។ ផ្នែកធនធានមនុស្ស អាចបញ្ចូលការវាយតម្លៃក្រៅប្រព័ន្ធបានផងដែរ នៅពេលចាំបាច់។',
        images: [
          '/images/products/hr-perf-kpi.png',
          '/images/products/hr-perf-template.png',
          '/images/products/hr-perf-review.png',
        ],
      },
      {
        icon: '💰',
        title: 'Payroll',
        description:
          'កំណត់ធាតុប្រាក់ខែ OT ពន្ធលើប្រាក់ខែ គោលនយោបាយប្រាក់ខែ រយៈពេលប្រាក់ខែ ប្រាក់បន្ថែមវេន និងគោលនយោបាយថែទាំកូន។ បុគ្គលិកដាក់សំណើ OT ដើម្បីអនុម័ត។ ធនធានមនុស្ស បញ្ចូលចំនួនអថេរក្នុង Pay Queue បន្ទាប់មកគណនា ពិនិត្យ និងអនុម័តបញ្ជីការគណនាប្រាក់ខែ — បោះពុម្ពស្លឹកប្រាក់ខែ និងដំណើរការរបាយការណ៍ពន្ធ NSSF អាយុការ និងបញ្ជីធនាគារ។',
        images: [
          '/images/products/hr-payroll-element.png',
          '/images/products/hr-payroll-otpolicy.png',
          '/images/products/hr-payroll-salarytax.png',
          '/images/products/hr-payroll-otpayrequest.png',
          '/images/products/hr-payroll-register.png',
          '/images/products/hr-payroll-tos.png',
          '/images/products/hr-payroll-nssf1.png',
          '/images/products/hr-payroll-nssf2.png',
          '/images/products/hr-mypayslip.png',
          '/images/products/hr-payroll-payslip.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS HRMS | ការគ្រប់គ្រងបុគ្គលិក វត្តមាន ការឈប់សម្រាក ការគណនាប្រាក់ខែ និងសេវាកម្មបុគ្គលិកដោយខ្លួនឯង',
      description:
        'AKAS HRMS គ្របដណ្តប់ការជ្រើសរើសបុគ្គលិក ការគ្រប់គ្រងបុគ្គលិក វត្តមាន ការឈប់សម្រាក ការវាយតម្លៃការងារ ការគណនាប្រាក់ខែ (ពន្ធ NSSF អាយុការ) ការបណ្តុះបណ្តាល និងសេវាកម្មបុគ្គលិកដោយខ្លួនឯង ជាមួយលំហូរការងារអនុម័ត។',
      keywords:
        'HRMS, HRIS, ការគណនាប្រាក់ខែ NSSF, ពន្ធលើប្រាក់ខែ, ការគ្រប់គ្រងការឈប់សម្រាក, វត្តមាន, ការជ្រើសរើសបុគ្គលិក, សេវាកម្មបុគ្គលិកដោយខ្លួនឯង, AKAS',
    },
    additionalFeatures: [
      {
        icon: '✓',
        title: 'លំហូរការងារអនុម័ត',
        description:
          'រៀបចំការអនុម័តច្រើនជំហានសម្រាប់ការឈប់សម្រាក OT សំណើ និងផ្សេងទៀត។ ប្រគល់សិទ្ធិអនុម័តនៅពេលអ្នកទទួលបន្ទុកអវត្តមាន។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ភាសាអង់គ្លេស និងខ្មែរមានស្រាប់។ បន្ថែមភាសាផ្សេងទៀតពីការបកប្រែក្នុង System Administration។',
      },
      {
        icon: '📁',
        title: 'ការគ្រប់គ្រងឯកសារ',
        description: 'រក្សាកិច្ចសន្យា CV និងឯកសារបុគ្គលិកជាមួយកំណត់ត្រាការគ្រប់គ្រងបុគ្គលិក។',
      },
      {
        icon: '⚙️',
        title: 'ទម្រង់អេក្រង់ និងវាលបន្ថែម',
        description: 'បន្ថែមវាល និងរៀបចំអេក្រង់ឡើងវិញ ដោយមិនចាំបាច់សាងសង់ទម្រង់ពិសេស។',
      },
      {
        icon: '🔔',
        title: 'ការជូនដំណឹង',
        description: 'សារអ៊ីមែល និងក្នុងកម្មវិធី សម្រាប់សំណើ ការអនុម័ត និងព្រឹត្តិការណ៍ការគណនាប្រាក់ខែ។',
      },
      {
        icon: '📝',
        title: 'កំណត់ត្រាសវនកម្ម',
        description: 'កំណត់ត្រាទិន្នន័យបង្ហាញថាអ្នកណាបានផ្លាស់ប្តូរវាលធនធានមនុស្ស រសើប និងពេលណា។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'កាត់បន្ថយក្រដាសសម្រាប់ធនធានមនុស្ស',
        description:
          'បុគ្គលិកដាក់សំណើឈប់សម្រាក OT ការបណ្តុះបណ្តាល និងលាលែងពីការងារដោយខ្លួនឯង។ ធនធានមនុស្ស ពិនិត្យតែករណីខុសពីធម្មតា ជំនួសការវាយបញ្ចូលទម្រង់ឡើងវិញ។',
      },
      {
        number: '02',
        title: 'ការគណនាប្រាក់ខែដែលត្រូវនឹងច្បាប់ក្នុងស្រុក',
        description:
          'ពន្ធលើប្រាក់ខែ NSSF អាយុការ និងបញ្ជីធនាគារ ជាផ្នែកនៃបញ្ជីការគណនាប្រាក់ខែ — មិនមែនជា Excel ដាច់ដោយឡែកក្រោយពេលបើកប្រាក់ខែទេ។',
      },
      {
        number: '03',
        title: 'កំណត់ត្រាបុគ្គលិកតែមួយ',
        description:
          'ការចាត់ចូលធ្វើការ កិច្ចសន្យា វត្តមាន សមតុល្យឈប់សម្រាក ការវាយតម្លៃ និងស្លឹកប្រាក់ខែ ស្ថិតលើបុគ្គលតែម្នាក់ — ដូច្នេះការប្តូរតួនាទី និងការចាកចេញនៅតែត្រឹមត្រូវ។',
      },
      {
        number: '04',
        title: 'ការអនុម័តដែលបញ្ជាក់បាន',
        description:
          'លំហូរការងារកំណត់បាន ការប្រគល់សិទ្ធិ និងកំណត់ត្រាសវនកម្ម ផ្តល់ផ្លូវដានសម្រាប់ពិនិត្យការងារ ពន្ធ និងការគ្រប់គ្រងផ្ទៃក្នុង។',
      },
    ],
    videos: [
      {
        title: 'លំហូរការងារអនុម័តបត់បែន',
        youtubeId: 'Rt-Zk9H0rNg',
        description: 'រចនាលំហូរការងារអនុម័តក្នុង AKAS។',
      },
      {
        title: 'ការញែក Resume',
        youtubeId: '5-htzI5-TVQ',
        description: 'ការញែក resume ដោយជំនួយ AI ក្នុងការជ្រើសរើសបុគ្គលិក។',
      },
      {
        title: 'Demo HRMS ជាភាសាខ្មែរ',
        youtubeId: 'sOLBiaDt1IE',
        description: 'Demo AKAS HRMS ជាភាសាខ្មែរ។',
      },
      {
        title: 'ការកែតម្រូវ',
        youtubeId: 'RlB4MXPjYXs',
        description: 'Demo ទម្រង់អេក្រង់ និងការកែតម្រូវ។',
      },
    ],
    related: [
      { label: 'Platform និងលំហូរការងារ', to: '/products/platform' },
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើ HRMS', href: `${DOCS_ORIGIN}/en/hrms/` },
    ],
  },
  {
    id: 2,
    slug: 'crm',
    name: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
    shortName: 'CRM',
    navLabel: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន (CRM)',
    tagline: 'ពីការទាក់ទងដំបូងដល់សម្រង់តម្លៃដែលមានតម្លៃច្បាស់',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/crm/`,
    description:
      'AKAS ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន ដំណើរការ pipeline លក់ពីអតិថិជនសក្តានុពលដល់សម្រង់តម្លៃ។ ចាប់ព័ត៌មានអតិថិជនសក្តានុពល បម្លែងជាអតិថិជន តាមដានតម្លៃឱកាសលក់ និងលទ្ធភាព ផ្ញើសម្រង់តម្លៃផ្លូវការ បន្ទាប់មកបន្តក្នុងការគ្រប់គ្រងចំណូល ជាមួយបញ្ជាលក់ វិក្កយបត្រ និងបង្កាន់ដៃ។ ទិន្នន័យអតិថិជនចែករំលែកជាមួយការចេញវិក្កយបត្រ ដូច្នេះផ្នែកលក់ និងហិរញ្ញវត្ថុមើលគណនីតែមួយ។',
    images: [
      '/images/products/crm/crm-leads.png',
      '/images/products/crm/crm-lead-form.png',
      '/images/products/crm/crm-customers.png',
      '/images/products/crm/crm-customer-form.png',
      '/images/products/crm/crm-opportunities.png',
      '/images/products/crm/crm-opportunity-form.png',
      '/images/products/crm/crm-pipeline.png',
      '/images/products/crm/crm-quotations.png',
      '/images/products/crm/crm-quotation-form.png',
      '/images/products/crm/crm-customer-sales-history.png',
      '/images/products/crm/crm-reports.png',
    ],
    backgroundImage: '/images/products/crm/crm-pipeline.png',
    highlights: [
      'Lead បម្លែងជាអតិថិជន និងឱកាសលក់តាមជម្រើស',
      'ដំណាក់កាល pipeline ជាមួយតម្លៃឱកាសលក់ និងលទ្ធភាព',
      'សម្រង់តម្លៃអនុម័ត និងបម្លែងជាបញ្ជាលក់',
      'ប្រវត្តិលក់អតិថិជន និងរបាយការណ៍ ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
    ],
    workflow: {
      title: 'ពី Lead ដល់សម្រង់តម្លៃ',
      path: 'Leads → Customers → Opportunities → Quotations → ការគ្រប់គ្រងចំណូល',
      steps: [
        {
          title: 'ចាប់អតិថិជនសក្តានុពល',
          description: 'កត់ត្រាព័ត៌មានទំនាក់ទំនង និងប្រភព ដើម្បីឱ្យការតាមដានមិនបាត់ក្នុងប្រអប់អ៊ីមែល។',
        },
        {
          title: 'បម្លែងជាអតិថិជន',
          description: 'បង្កើតគណនីអតិថិជនដែល ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន និង ការគ្រប់គ្រងចំណូល ប្រើរួមគ្នា អាចភ្ជាប់ឱកាសលក់ផងដែរ។',
        },
        {
          title: 'ដំណើរការឱកាសលក់',
          description: 'តាមដានតម្លៃ ដំណាក់កាល និងលទ្ធភាពលើ pipeline ដែលក្រុមអាចគ្រប់គ្រងបានពិតប្រាកដ។',
        },
        {
          title: 'សម្រង់តម្លៃ បន្ទាប់មកចេញវិក្កយបត្រ',
          description: 'ផ្ញើសម្រង់តម្លៃផ្លូវការ។ បន្ទាប់ពីអនុម័ត បម្លែងជាបញ្ជាលក់ក្នុងការគ្រប់គ្រងចំណូល។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ទំព័រ pipeline',
        items: [
          'Lead អតិថិជន ឱកាសលក់ សម្រង់តម្លៃ និងទិដ្ឋភាព pipeline',
          'ប្រវត្តិលក់អតិថិជនតាមបញ្ជាលក់ និងវិក្កយបត្រ',
          'របាយការណ៍ ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន សម្រាប់សកម្មភាព និងអត្រាបម្លែង',
        ],
      },
      {
        title: 'តភ្ជាប់ជាមួយការចេញវិក្កយបត្រ',
        items: [
          'ទិន្នន័យអតិថិជនចែករំលែកជាមួយ ការគ្រប់គ្រងចំណូល',
          'សម្រង់តម្លៃដែលបានអនុម័តក្លាយជាបញ្ជាលក់ បន្ទាប់មកវិក្កយបត្រ និងបង្កាន់ដៃ',
          'លក្ខខណ្ឌឥណទានពី System Administration អនុវត្តលើឯកសារលក់',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '👤',
        title: 'Lead និងអតិថិជន',
        description:
          'ចាប់អតិថិជនសក្តានុពល បម្លែងជាអតិថិជន និងរក្សាគណនីតែមួយសម្រាប់ប្រវត្តិលក់ សម្រង់តម្លៃ វិក្កយបត្រ និងបង្កាន់ដៃ។ ភ្ជាប់កំណត់ចំណាំ និងឯកសារ ដើម្បីឱ្យអ្នកទូរស័ព្ទបន្ទាប់មានបរិបទ។',
        images: [
          '/images/products/crm/crm-leads.png',
          '/images/products/crm/crm-lead-form.png',
          '/images/products/crm/crm-customers.png',
          '/images/products/crm/crm-customer-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'ឱកាសលក់ និង pipeline',
        description:
          'តាមដានតម្លៃឱកាសលក់ ដំណាក់កាល និងលទ្ធភាព។ ទិដ្ឋភាព pipeline បង្ហាញថាចំណូលស្ថិតនៅត្រង់ណា ដូច្នេះអ្នកគ្រប់គ្រងអាចណែនាំឱកាសលក់ត្រឹមត្រូវ មិនមែនមើលតែវិក្កយបត្រខែមុនទេ។',
        images: [
          '/images/products/crm/crm-opportunities.png',
          '/images/products/crm/crm-opportunity-form.png',
          '/images/products/crm/crm-pipeline.png',
        ],
      },
      {
        icon: '📝',
        title: 'សម្រង់តម្លៃ',
        description:
          'បង្កើតសម្រង់តម្លៃលម្អិតតាមទំនិញ ជាមួយពន្ធ បញ្ចុះតម្លៃ និងលក្ខខណ្ឌទូទាត់។ បញ្ជូនឱ្យអនុម័ត ផ្ញើទៅអតិថិជន បន្ទាប់មកបម្លែងជាបញ្ជាលក់ដោយមិនវាយបញ្ចូលជួរឡើងវិញ។',
        images: [
          '/images/products/crm/crm-quotations.png',
          '/images/products/crm/crm-quotation-form.png',
        ],
      },
      {
        icon: '📈',
        title: 'ប្រវត្តិលក់ និងរបាយការណ៍',
        description:
          'ឃើញថាអតិថិជនបានទិញអ្វី សម្រង់តម្លៃណាដែលបានបម្លែង និង pipeline ដើរយ៉ាងណា — ដោយប្រើទំនិញ និងពន្ធដូចគ្នានឹងការគ្រប់គ្រងចំណូល។',
        images: [
          '/images/products/crm/crm-customer-sales-history.png',
          '/images/products/crm/crm-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន | Lead, pipeline, សម្រង់តម្លៃ និងប្រវត្តិអតិថិជន',
      description:
        'AKAS ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន គ្រប់គ្រង Lead អតិថិជន ឱកាសលក់ សម្រង់តម្លៃ និងរបាយការណ៍ pipeline បន្ទាប់មកផ្ទេរទៅបញ្ជាលក់ និងវិក្កយបត្រក្នុងការគ្រប់គ្រងចំណូល។',
      keywords: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន, CRM, sales pipeline, សម្រង់តម្លៃ, Lead, ការគ្រប់គ្រងអតិថិជន, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ដំណើរការលក់ជាភាសាដែលក្រុមរបស់អ្នកប្រើពិតប្រាកដ។',
      },
      {
        icon: '✓',
        title: 'ការអនុម័តសម្រង់តម្លៃ',
        description: 'បញ្ចុះតម្លៃ និងសម្រង់តម្លៃធំ ឆ្លងកាត់លំហូរការងារមុនពេលក្លាយជាបញ្ជាលក់។',
      },
      {
        icon: '🔔',
        title: 'ការជូនដំណឹង',
        description: 'ជូនដំណឹងម្ចាស់ការងារពេល Lead ត្រូវបានចាត់តាំង ឬសម្រង់តម្លៃត្រូវការអនុម័ត។',
      },
      {
        icon: '🔌',
        title: 'ទិន្នន័យចែករំលែក',
        description: 'ទំនិញ ពន្ធ លក្ខខណ្ឌឥណទាន និងអតិថិជន ប្រើឡើងវិញក្នុងការគ្រប់គ្រងចំណូល, ការលក់តាមបញ្ជរ និងហាងអនឡាញ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'មិនវាយបញ្ចូលឡើងវិញពីសម្រង់តម្លៃដល់វិក្កយបត្រ',
        description:
          'សម្រង់តម្លៃដែលបានអនុម័តក្លាយជាបញ្ជាលក់។ ផ្នែកលក់ និងហិរញ្ញវត្ថុឈប់រក្សាកំណែពីរនៃកិច្ចសន្យាតែមួយ។',
      },
      {
        number: '02',
        title: 'Pipeline ដែលព្យាករណ៍បាន',
        description: 'ដំណាក់កាល តម្លៃ និងលទ្ធភាពស្ថិតលើឱកាសលក់ — មិនមែនក្នុង Excel ផ្ទាល់ខ្លួនទេ។',
      },
      {
        number: '03',
        title: 'កំណត់ត្រាអតិថិជនតែមួយ',
        description: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន វិក្កយបត្រ បង្កាន់ដៃ និងប្រាក់កក់ ទាំងអស់ចង្អុលទៅគណនីអតិថិជនតែមួយ។',
      },
      {
        number: '04',
        title: 'ការផ្ទេរកិច្ចការដែលមិនបាត់',
        description: 'ពេលសម្រង់តម្លៃឈ្នះ ការគ្រប់គ្រងចំណូលមានរួចហើយនូវអតិថិជន ទំនិញ ពន្ធ និងលក្ខខណ្ឌ។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន', href: `${DOCS_ORIGIN}/en/crm/` },
    ],
  },
  {
    id: 3,
    slug: 'insurance',
    name: 'ការគ្រប់គ្រងធានារ៉ាប់រង',
    shortName: 'Insurance',
    tagline: 'បណ្ណធានារ៉ាប់រង អតិថិជន ការទាមទារ និងការបន្ត',
    featured: false,
    description:
      'AKAS Insurance Management ជួយភ្នាក់ងារ និងក្រុមហ៊ុនធានារ៉ាប់រង រក្សាព័ត៌មានបណ្ណ អតិថិជន ការទាមទារ និងការបន្តនៅកន្លែងតែមួយ — ជាមួយការរំលឹក ការរក្សាឯកសារ និងរបាយការណ៍។',
    images: ['/images/products/insurance.jpeg'],
    backgroundImage: '/images/products/insurance.jpeg',
    highlights: [
      'បញ្ជីបណ្ណធានារ៉ាប់រង ជាមួយគម្រប និងថ្ងៃបន្ត',
      'ប្រវត្តិអតិថិជន និងកំណត់ត្រាទំនាក់ទំនង',
      'ការទាមទារពីការដាក់ពាក្យដល់ការដោះស្រាយ',
      'ការរំលឹកថ្ងៃបន្ត និងសម្រង់តម្លៃ',
    ],
    mainFeatures: [
      {
        icon: '📊',
        title: 'ការគ្រប់គ្រងបណ្ណ',
        description:
          'តាមដានបណ្ណ គម្រប និងថ្ងៃបន្ត។ ស្វែងរក ត្រង និងធ្វើរបាយការណ៍លើផលប័ត្រទាំងមូល ជំនួសការរកក្នុងឯកសារដាច់ៗ។',
      },
      {
        icon: '👥',
        title: 'ការគ្រប់គ្រងអតិថិជន',
        description: 'រក្សាព័ត៌មានផ្ទាល់ខ្លួន ទំនាក់ទំនង ប្រវត្តិបណ្ណ និងកំណត់ត្រាទំនាក់ទំនងលើអតិថិជនម្នាក់ៗ។',
      },
      {
        icon: '📝',
        title: 'ដំណើរការការទាមទារ',
        description: 'នាំការទាមទារពីការដាក់ពាក្យដល់ការដោះស្រាយ ជាមួយឯកសារ ស្ថានភាព និងការជូនដំណឹង។',
      },
      {
        icon: '📅',
        title: 'ការគ្រប់គ្រងការបន្ត',
        description: 'បង្ហាញថ្ងៃបន្តដែលមកដល់ រំលឹកអតិថិជន និងភ្នាក់ងារ ហើយបង្កើតសម្រង់តម្លៃបន្ត។',
      },
    ],
    meta: {
      title: 'AKAS Insurance Management | បណ្ណ ការទាមទារ និងការបន្ត',
      description:
        'គ្រប់គ្រងបណ្ណធានារ៉ាប់រង អតិថិជន ការទាមទារ និងការបន្ត ជាមួយការរំលឹក ឯកសារ និងរបាយការណ៍ក្នុង AKAS។',
      keywords: 'Insurance management, បណ្ណធានារ៉ាប់រង, ការទាមទារ, ការបន្ត, AKAS',
    },
    additionalFeatures: [
      {
        icon: '💰',
        title: 'ការគណនាប្រាក់ធានារ៉ាប់រង',
        description: 'គណនាប្រាក់ធានារ៉ាប់រងពីកត្តាកំណត់ចំណាត់ថ្នាក់ដែលកែបាន។',
      },
      {
        icon: '🔒',
        title: 'ការរក្សាឯកសារ',
        description: 'រក្សាឯកសារបណ្ណ កញ្ចប់ការទាមទារ និងការឆ្លើយឆ្លងអតិថិជន។',
      },
      {
        icon: '📨',
        title: 'ការទំនាក់ទំនងស្វ័យប្រវត្តិ',
        description: 'អ៊ីមែល និង SMS សម្រាប់ការបន្ត ប្រាក់ធានារ៉ាប់រង និងបច្ចុប្បន្នភាពការទាមទារ។',
      },
      {
        icon: '⚙️',
        title: 'លំហូរការងារតាមតម្រូវការ',
        description: 'ផ្លូវផ្សេងគ្នាសម្រាប់ប្រភេទបណ្ណ ប្រភេទអតិថិជន និងការទាមទារ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ប្រតិបត្តិការលឿនជាង',
        description: 'បណ្ណ ការទាមទារ និងការបន្ត មិនស្ថិតក្នុងថតឯកសារដាច់ដោយឡែកទៀតទេ។',
      },
      {
        number: '02',
        title: 'សេវាអតិថិជនល្អប្រសើរ',
        description: 'ឆ្លើយតបដោយមានព័ត៌មានបណ្ណ និងប្រវត្តិនៅមុខអ្នក។',
      },
      {
        number: '03',
        title: 'ការបន្តមិនខកខាន',
        description: 'ថ្ងៃបន្ត និងការរំលឹកស្ថិតលើបណ្ណ មិនមែនក្នុងប្រតិទិនដែលគេមិនចែករំលែកទេ។',
      },
      {
        number: '04',
        title: 'ផ្លូវដានសម្រាប់ការពិនិត្យ',
        description: 'ឯកសារ និងប្រវត្តិស្ថានភាពស្ថិតជាមួយបណ្ណ និងការទាមទារ។',
      },
    ],
  },
  {
    id: 4,
    slug: 'revenues',
    name: 'ការគ្រប់គ្រងចំណូល',
    shortName: 'ការគ្រប់គ្រងចំណូល',
    navLabel: 'ការគ្រប់គ្រងចំណូល',
    tagline: 'ពីសម្រង់តម្លៃដល់សាច់ប្រាក់៖ បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងគណនីត្រូវទទួល (AR)',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/revenue/`,
    description:
      'ការគ្រប់គ្រងចំណូល គឺជាវដ្តលក់ដល់សាច់ប្រាក់ក្នុង AKAS។ បន្ទាប់ពីសម្រង់តម្លៃក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន អ្នកបញ្ជាក់បញ្ជាលក់ ចេញវិក្កយបត្រ កត់ត្រាបង្កាន់ដៃ ទទួលប្រាក់កក់អតិថិជន និងតាមដានគណនីត្រូវទទួល (AR)។ ផលិតផល និងសេវាកម្ម កម្រិតតម្លៃ VAT កូប៉ុន និងការទទួលបង់ KHQR កំណត់តែម្តង ហើយប្រើឡើងវិញដោយ ការលក់តាមបញ្ជរ និងហាងអនឡាញ។ វិក្កយបត្រដែលបានអនុម័តអាចចុះបញ្ជីប្រតិបត្តិការទៅសៀវភៅគណនីទូទៅ តាមរយៈការភ្ជាប់គណនេយ្យ។',
    images: [
      '/images/products/revenues/revenue-items.png',
      '/images/products/revenues/revenue-item-form.png',
      '/images/products/revenues/revenue-taxes.png',
      '/images/products/revenues/revenue-tax-form.png',
      '/images/products/revenues/revenue-coupons.png',
      '/images/products/revenues/revenue-coupon-form.png',
      '/images/products/revenues/revenue-payment-acceptance.png',
      '/images/products/revenues/revenue-sale-orders.png',
      '/images/products/revenues/revenue-sale-order-form.png',
      '/images/products/revenues/revenue-invoices.png',
      '/images/products/revenues/revenue-invoice-form.png',
      '/images/products/revenues/revenue-receipts.png',
      '/images/products/revenues/revenue-receipt-form.png',
      '/images/products/revenues/revenue-customer-deposits.png',
      '/images/products/revenues/revenue-customer-deposit-form.png',
      '/images/products/revenues/revenue-deposit-applications.png',
      '/images/products/revenues/revenue-deposit-application-form.png',
      '/images/products/revenues/revenue-deposit-refunds.png',
      '/images/products/revenues/revenue-deposit-refund-form.png',
      '/images/products/revenues/revenue-ar-query.png',
      '/images/products/revenues/revenue-item-sales-history.png',
      '/images/products/revenues/revenue-reports.png',
    ],
    backgroundImage: '/images/products/revenues/revenue-sale-orders.png',
    highlights: [
      'បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងប្រាក់កក់អតិថិជន',
      'ទំនិញជាមួយកម្រិតតម្លៃ ពន្ធ កូប៉ុន និងប្រភេទ',
      'KHQR និងវិធីទទួលបង់ផ្សេងទៀត',
      'សំណួរគណនីត្រូវទទួល (AR) និងរបាយការណ៍ចំណូល',
    ],
    workflow: {
      title: 'ពីសម្រង់តម្លៃដល់សាច់ប្រាក់',
      path: 'Quotation → Sales order → Invoice → Receipt',
      steps: [
        {
          title: 'សម្រង់តម្លៃក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
          description: 'ផ្ញើសម្រង់តម្លៃដែលមានតម្លៃច្បាស់។ ពេលឈ្នះ បម្លែងដោយមិនវាយបញ្ចូលជួរឡើងវិញ។',
        },
        {
          title: 'បញ្ជាក់បញ្ជាលក់',
          description: 'អតិថិជនយល់ព្រម បញ្ជាលក់ត្រូវអនុម័ត និងអាចកក់ស្តុក។',
        },
        {
          title: 'វិក្កយបត្រ',
          description: 'ចេញវិក្កយបត្រសម្រាប់ទំនិញ ឬសេវាកម្ម។ ស្តុកលើទំនិញដែលតាមដានស្តុក ត្រូវដកនៅពេលចេញវិក្កយបត្រ។',
        },
        {
          title: 'ប្រមូលប្រាក់',
          description:
            'កត់ត្រាបង្កាន់ដៃ អនុវត្តប្រាក់កក់អតិថិជន ឬសងប្រាក់កក់ដែលមិនបានប្រើ។ សួរគណនីត្រូវទទួល (AR) បានគ្រប់ពេល។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ទំនិញ និងសេវាកម្ម រួមទាំងកម្រិតតម្លៃ',
          'និយមន័យ VAT និងពន្ធលក់',
          'កូប៉ុន / លេខកូដបញ្ចុះតម្លៃ',
          'ការទទួលបង់ដូចជា KHQR',
          'ប្រភេទទំនិញ ជាមួយការកំណត់គណនី GL តាមជម្រើស',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'បញ្ជាលក់ វិក្កយបត្រ និងបង្កាន់ដៃ',
          'ប្រាក់កក់អតិថិជន ការអនុវត្តប្រាក់កក់ និងការសងត្រឡប់',
          'សំណួរគណនីត្រូវទទួល (AR)',
          'ប្រវត្តិលក់ទំនិញតាមលម្អិត ឬតាមអតិថិជន',
          'របាយការណ៍ចំណូល',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '📦',
        title: 'ទំនិញ ពន្ធ និងកម្រិតតម្លៃ',
        description:
          'រក្សាផលិតផល និងសេវាកម្មដែលអ្នកលក់ ជាមួយកម្រិតតម្លៃ VAT កូប៉ុន និងប្រភេទ។ បញ្ជីទំនិញតែមួយនេះផ្គត់ផ្គង់សម្រង់តម្លៃ វិក្កយបត្រ ការលក់តាមបញ្ជរ និងហាងអនឡាញ។',
        images: [
          '/images/products/revenues/revenue-items.png',
          '/images/products/revenues/revenue-item-form.png',
          '/images/products/revenues/revenue-taxes.png',
          '/images/products/revenues/revenue-tax-form.png',
          '/images/products/revenues/revenue-coupons.png',
          '/images/products/revenues/revenue-coupon-form.png',
          '/images/products/revenues/revenue-payment-acceptance.png',
        ],
      },
      {
        icon: '🧾',
        title: 'បញ្ជាលក់ និងវិក្កយបត្រ',
        description:
          'បញ្ជាក់បញ្ជាលក់ពីសម្រង់តម្លៃដែលឈ្នះ បន្ទាប់មកចេញវិក្កយបត្រ។ ទំនិញស្តុកត្រូវដកនៅពេលចេញវិក្កយបត្រ ដូច្នេះសមតុល្យឃ្លាំងត្រូវនឹងការលក់។',
        images: [
          '/images/products/revenues/revenue-sale-orders.png',
          '/images/products/revenues/revenue-sale-order-form.png',
          '/images/products/revenues/revenue-invoices.png',
          '/images/products/revenues/revenue-invoice-form.png',
        ],
      },
      {
        icon: '💳',
        title: 'បង្កាន់ដៃ ប្រាក់កក់ និង KHQR',
        description:
          'កត់ត្រាការទូទាត់លើវិក្កយបត្រ ទទួលប្រាក់កក់អតិថិជន អនុវត្ត ឬសងត្រឡប់នៅពេលក្រោយ និងទទួលវិធីស្កេនបង់ដូចជា KHQR។ វិក្កយបត្រដែលបានអនុម័តមានតំណចែករំលែក៖ អតិថិជនបើកទំព័រវិក្កយបត្រស្អាតលើទូរស័ព្ទ បោះពុម្ព PDF និងអាចបង់ក្នុងមួយចុច — សាច់ប្រាក់មកដល់លឿនជាង។',
        images: [
          '/images/products/revenues/revenue-receipts.png',
          '/images/products/revenues/revenue-receipt-form.png',
          '/images/products/revenues/revenue-customer-deposits.png',
          '/images/products/revenues/revenue-customer-deposit-form.png',
          '/images/products/revenues/revenue-deposit-applications.png',
          '/images/products/revenues/revenue-deposit-application-form.png',
          '/images/products/revenues/revenue-deposit-refunds.png',
          '/images/products/revenues/revenue-deposit-refund-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'គណនីត្រូវទទួល និងរបាយការណ៍',
        description:
          'ឃើញវិក្កយបត្រមិនទាន់បង់ទាំងអស់ តាមអតិថិជន និងអាយុបំណុល — ដូច្នេះការគ្រប់គ្រងឥណទានដឹងច្បាស់ថាត្រូវទូរស័ព្ទអ្នកណា។ បញ្ជីប្រតិបត្តិការ VAT និងពន្ធកាត់ទុកសម្រាប់ដាក់ពន្ធ ចេញរួចរាល់ ហើយវិក្កយបត្រដែលបានភ្ជាប់ចុះបញ្ជីទៅគណនេយ្យសម្រាប់របាយការណ៍ចំណេញខាត និងលំហូរសាច់ប្រាក់។',
        images: [
          '/images/products/revenues/revenue-ar-query.png',
          '/images/products/revenues/revenue-item-sales-history.png',
          '/images/products/revenues/revenue-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS ការគ្រប់គ្រងចំណូល | បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងគណនីត្រូវទទួល',
      description:
        'AKAS ការគ្រប់គ្រងចំណូល គ្រប់គ្រងទំនិញ បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ ប្រាក់កក់អតិថិជន ការទូទាត់ KHQR និងគណនីត្រូវទទួល (AR) — ចុះបញ្ជីទៅសៀវភៅគណនីទូទៅនៅពេលបានភ្ជាប់។',
      keywords: 'វិក្កយបត្រ, បញ្ជាលក់, បង្កាន់ដៃ, KHQR, គណនីត្រូវទទួល, VAT, AKAS',
    },
    additionalFeatures: [
      {
        icon: '💱',
        title: 'ពហុរូបិយប័ណ្ណ',
        description: 'កំណត់តម្លៃ និងប្រមូលជារូបិយប័ណ្ណដែលបានកំណត់ ជាមួយអត្រាប្តូរពីការរៀបចំ។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ឯកសារ និងអេក្រង់ជាភាសាដែលក្រុម និងអតិថិជនប្រើ។',
      },
      {
        icon: '✓',
        title: 'ការអនុម័ត',
        description: 'អនុម័តបញ្ជាលក់ និងវិក្កយបត្រតាមម៉ាស៊ីនលំហូរការងារដូចគ្នានឹងផ្នែកផ្សេងនៃ AKAS។',
      },
      {
        icon: '📒',
        title: 'ចុះបញ្ជីទៅ GL',
        description: 'ការភ្ជាប់ប្រតិបត្តិការបញ្ជូនវិក្កយបត្រ និងបង្កាន់ដៃដែលបានអនុម័តទៅបញ្ជីប្រតិបត្តិការ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'សាច់ប្រាក់ដែលអ្នកឃើញ',
        description:
          'បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងប្រាក់កក់ ជាខ្សែតែមួយ — គណនីត្រូវទទួល (AR) មិនមែនជាសៀវភៅដាច់ដោយឡែកទេ។',
      },
      {
        number: '02',
        title: 'ស្តុកដែលត្រូវនឹងការលក់',
        description: 'ការចេញវិក្កយបត្រទំនិញស្តុក ដកសមតុល្យឃ្លាំងដោយស្វ័យប្រវត្តិ។',
      },
      {
        number: '03',
        title: 'ការទូទាត់ក្នុងស្រុក',
        description: 'KHQR និងវិធីទទួលបង់ផ្សេងទៀត ស្ថិតក្បែរបង្កាន់ដៃធម្មតា។',
      },
      {
        number: '04',
        title: 'សៀវភៅគណនេយ្យដើរតាមការលក់',
        description: 'ប្រតិបត្តិការដែលបានភ្ជាប់ចុះបញ្ជីទៅគណនេយ្យ ដូច្នេះ P&L មិនត្រូវវាយពីរដងទេ។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន', to: '/products/crm' },
      { label: 'Inventory', to: '/products/inventory' },
      { label: 'Accounting', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើការគ្រប់គ្រងចំណូល', href: `${DOCS_ORIGIN}/en/revenue/` },
    ],
  },
  {
    id: 5,
    slug: 'expenses',
    name: 'Expenses & Payables',
    shortName: 'Expenses',
    navLabel: 'ចំណាយ និងការទិញ',
    tagline: 'អ្នកផ្គត់ផ្គង់ វិក្កយបត្រទិញ ការទូទាត់ និងគណនីត្រូវបង់ (AP)',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/expense/`,
    description:
      'Expenses គឺជាគណនីត្រូវបង់ (AP) ក្នុង AKAS៖ ទិន្នន័យអ្នកផ្គត់ផ្គង់ ទំនិញចំណាយ វិក្កយបត្រទិញ ការទូទាត់វិក្កយបត្រ និងប្រាក់កក់អ្នកផ្គត់ផ្គង់។ ចុះឈ្មោះអ្នកផ្គត់ផ្គង់ កត់ត្រាវិក្កយបត្ររបស់គេ ទូទាត់ និងភ្ជាប់ ឬបង់ជាមុនដោយប្រាក់កក់ បន្ទាប់មកអនុវត្ត ឬសងត្រឡប់នៅពេលក្រោយ។ សំណួរគណនីត្រូវបង់ និងរបាយការណ៍ចំណាយ បង្ហាញថាអ្នកជំពាក់ប៉ុន្មាន។ វិក្កយបត្រ និងការទូទាត់ដែលបានអនុម័ត ចុះបញ្ជីទៅសៀវភៅគណនេយ្យតាមការភ្ជាប់គណនេយ្យ។ បញ្ជាទិញ និងការទទួលទំនិញស្ថិតនៅក្បែរក្នុង Inventory។',
    images: [
      '/images/products/expenses/expense-vendors.png',
      '/images/products/expenses/expense-vendor-form.png',
      '/images/products/expenses/expense-items.png',
      '/images/products/expenses/expense-item-form.png',
      '/images/products/expenses/expense-bills.png',
      '/images/products/expenses/expense-bill-form.png',
      '/images/products/expenses/expense-payments.png',
      '/images/products/expenses/expense-payment-form.png',
      '/images/products/expenses/expense-vendor-deposits.png',
      '/images/products/expenses/expense-vendor-deposit-form.png',
      '/images/products/expenses/expense-vendor-deposit-applications.png',
      '/images/products/expenses/expense-vendor-deposit-application-form.png',
      '/images/products/expenses/expense-vendor-deposit-refunds.png',
      '/images/products/expenses/expense-vendor-deposit-refund-form.png',
      '/images/products/expenses/expense-ap-query.png',
      '/images/products/expenses/expense-reports.png',
    ],
    backgroundImage: '/images/products/expenses/expense-bills.png',
    highlights: [
      'ទិន្នន័យអ្នកផ្គត់ផ្គង់ វិក្កយបត្រទិញ និងការទូទាត់',
      'ប្រាក់កក់អ្នកផ្គត់ផ្គង់ ជាមួយការអនុវត្ត និងការសងត្រឡប់',
      'សំណួរគណនីត្រូវបង់ (AP) និងរបាយការណ៍ចំណាយ',
      'ចុះបញ្ជីទៅគណនេយ្យ នៅពេលការភ្ជាប់ GL ត្រូវបានកំណត់',
    ],
    workflow: {
      title: 'ពីការទិញដល់ការទូទាត់',
      path: 'Vendor → Bill → Payment  (or Vendor deposit → Apply / Refund)',
      steps: [
        {
          title: 'ចុះឈ្មោះអ្នកផ្គត់ផ្គង់',
          description:
            'រក្សាព័ត៌មានអ្នកផ្គត់ផ្គង់ លក្ខខណ្ឌ និងទំនាក់ទំនងតែម្តង — ប្រើឡើងវិញក្នុងការទិញស្តុក និងទ្រព្យសកម្ម។',
        },
        {
          title: 'កត់ត្រាវិក្កយបត្រទិញ',
          description: 'បញ្ចូលវិក្កយបត្រអ្នកផ្គត់ផ្គង់លើទំនិញចំណាយ ឬទំនិញដែលបានទទួល។',
        },
        {
          title: 'ទូទាត់ និងភ្ជាប់',
          description: 'កត់ត្រាការទូទាត់វិក្កយបត្រ និងភ្ជាប់ទៅវិក្កយបត្រមិនទាន់បង់។',
        },
        {
          title: 'ប្រាក់កក់ពេលបង់ជាមុន',
          description: 'ដាក់ប្រាក់កក់អ្នកផ្គត់ផ្គង់ អនុវត្តទៅវិក្កយបត្រក្រោយៗ ឬសងចំនួនដែលមិនបានប្រើ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ទំនិញចំណាយ និងសេវាកម្មដែលអ្នកទិញ',
          'ទិន្នន័យអ្នកផ្គត់ផ្គង់',
          'ប្រភេទចែករំលែក ជាមួយការកំណត់គណនី GL តាមជម្រើស',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'វិក្កយបត្រទិញ និងការទូទាត់វិក្កយបត្រ',
          'ប្រាក់កក់អ្នកផ្គត់ផ្គង់ ការអនុវត្ត និងការសងត្រឡប់',
          'សំណួរគណនីត្រូវបង់ (AP)',
          'របាយការណ៍ចំណាយ',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '👥',
        title: 'ការគ្រប់គ្រងអ្នកផ្គត់ផ្គង់',
        description:
          'កំណត់ត្រាអ្នកផ្គត់ផ្គង់តែមួយសម្រាប់វិក្កយបត្រទិញ ការទូទាត់ បញ្ជាទិញ និងការទិញទ្រព្យ — រួមទាំងលក្ខខណ្ឌដែលប្រើពេលអ្នកទូទាត់។',
        images: [
          '/images/products/expenses/expense-vendors.png',
          '/images/products/expenses/expense-vendor-form.png',
        ],
      },
      {
        icon: '📄',
        title: 'វិក្កយបត្រទិញ និងការទូទាត់',
        description:
          'កត់ត្រាវិក្កយបត្រអ្នកផ្គត់ផ្គង់ ទូទាត់ និងភ្ជាប់ការទូទាត់ទៅវិក្កយបត្រមិនទាន់បង់ ដូច្នេះអាយុបំណុលគណនីត្រូវបង់ (AP) នៅតែត្រឹមត្រូវ។',
        images: [
          '/images/products/expenses/expense-bills.png',
          '/images/products/expenses/expense-bill-form.png',
          '/images/products/expenses/expense-payments.png',
          '/images/products/expenses/expense-payment-form.png',
        ],
      },
      {
        icon: '💰',
        title: 'ប្រាក់កក់អ្នកផ្គត់ផ្គង់',
        description:
          'បង់ជាមុនអ្នកផ្គត់ផ្គង់ អនុវត្តប្រាក់កក់ទៅវិក្កយបត្រក្រោយៗ ឬសងចំនួនដែលមិនបានប្រើ — ជាមួយផ្លូវដានពេញលេញ។',
        images: [
          '/images/products/expenses/expense-vendor-deposits.png',
          '/images/products/expenses/expense-vendor-deposit-form.png',
          '/images/products/expenses/expense-vendor-deposit-applications.png',
          '/images/products/expenses/expense-vendor-deposit-application-form.png',
          '/images/products/expenses/expense-vendor-deposit-refunds.png',
          '/images/products/expenses/expense-vendor-deposit-refund-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'សំណួរគណនីត្រូវបង់ និងរបាយការណ៍',
        description:
          'ឃើញបំណុលមិនទាន់បង់ តាមអ្នកផ្គត់ផ្គង់ និងថ្ងៃផុតកំណត់។ វិក្កយបត្រ និងការទូទាត់ដែលបានភ្ជាប់ ចុះបញ្ជីប្រតិបត្តិការសម្រាប់លំហូរសាច់ប្រាក់ និង P&L។',
        images: [
          '/images/products/expenses/expense-ap-query.png',
          '/images/products/expenses/expense-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS Expenses | អ្នកផ្គត់ផ្គង់ វិក្កយបត្រទិញ ការទូទាត់ និងគណនីត្រូវបង់',
      description:
        'AKAS Expenses តាមដានអ្នកផ្គត់ផ្គង់ វិក្កយបត្រទិញ ការទូទាត់ ប្រាក់កក់អ្នកផ្គត់ផ្គង់ និងគណនីត្រូវបង់ (AP) ជាមួយការចុះបញ្ជីទៅសៀវភៅគណនីទូទៅតាមជម្រើស។',
      keywords: 'គណនីត្រូវបង់, វិក្កយបត្រទិញ, ការទូទាត់វិក្កយបត្រ, ចំណាយ, ការទិញ, AKAS',
    },
    additionalFeatures: [
      {
        icon: '📦',
        title: 'តភ្ជាប់ជាមួយស្តុក',
        description: 'បញ្ជាទិញ និងការទទួលទំនិញក្នុង Inventory ប្រើអ្នកផ្គត់ផ្គង់ដូចគ្នា។',
      },
      {
        icon: '✓',
        title: 'ការអនុម័ត',
        description: 'បញ្ជូនវិក្កយបត្រទិញ និងការទូទាត់តាមលំហូរការងារមុនពេលចុះបញ្ជី។',
      },
      {
        icon: '📒',
        title: 'ចុះបញ្ជីទៅ GL',
        description: 'ការភ្ជាប់គណនីបញ្ជូនគណនីត្រូវបង់ដែលបានអនុម័តទៅបញ្ជីប្រតិបត្តិការគណនេយ្យ។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ហិរញ្ញវត្ថុ និងប្រតិបត្តិការអាចធ្វើការជាភាសាណាមួយ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'គណនីត្រូវបង់ដែលត្រូវនឹងឃ្លាំង',
        description:
          'អ្នកផ្គត់ផ្គង់ បញ្ជាទិញ ការទទួលទំនិញ និងវិក្កយបត្រទិញ ចែករំលែកទិន្នន័យ ដូច្នេះការផ្ទៀងផ្ទាត់បីផ្នែកអាចធ្វើបាន។',
      },
      {
        number: '02',
        title: 'ប្រាក់កក់មិនបាត់',
        description:
          'ការបង់ជាមុនត្រូវអនុវត្ត ឬសងត្រឡប់ ជំនួសការស្ថិតក្នុងគណនីរង់ចាំដែលគេមិនផ្ទៀងផ្ទាត់។',
      },
      {
        number: '03',
        title: 'ទូទាត់តែចំនួនដែលអ្នកពិតជាជំពាក់',
        description: 'សំណួរគណនីត្រូវបង់ (AP) បង្ហាញវិក្កយបត្រមិនទាន់បង់ មុនពេលអ្នកចេញការទូទាត់។',
      },
      {
        number: '04',
        title: 'សៀវភៅគណនេយ្យដើរតាមការចំណាយ',
        description: 'វិក្កយបត្រទិញ និងការទូទាត់ដែលបានភ្ជាប់ ចូលសៀវភៅដោយមិនចាំបាច់ចម្លងនៅចុងខែ។',
      },
    ],
    related: [
      { label: 'Inventory', to: '/products/inventory' },
      { label: 'Accounting', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើ Expenses', href: `${DOCS_ORIGIN}/en/expense/` },
    ],
  },
  {
    id: 6,
    slug: 'inventory',
    name: 'ការគ្រប់គ្រងស្តុក',
    shortName: 'Inventory',
    navLabel: 'ការគ្រប់គ្រងស្តុក',
    tagline: 'ស្តុក បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ និងសមតុល្យ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/inventory/`,
    description:
      'Inventory គ្រប់គ្រងស្តុកជាក់ស្តែងតាមទីតាំង៖ ទំនិញដែលតាមដានបរិមាណ បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ ការកែតម្រូវ ការដកស្តុកក្រុមហ៊ុន និងសមតុល្យនៅដៃ។ ការលក់តាមការគ្រប់គ្រងចំណូល ដកស្តុក។ បុគ្គលិកអាចស្នើសុំដកស្តុកពីសេវាកម្មបុគ្គលិកដោយខ្លួនឯង។ សំណើដែលបានអនុម័ត បង្ហាញជាការដកស្តុកសម្រាប់ឃ្លាំង។ ទីតាំងមកពី System Administration ដូច្នេះហាង និងឃ្លាំងស្ថិតលើផែនទីអង្គភាព។',
    images: [
      '/images/products/inventory/inventory-items.png',
      '/images/products/inventory/inventory-item-form.png',
      '/images/products/inventory/inventory-purchase-orders.png',
      '/images/products/inventory/inventory-purchase-order-form.png',
      '/images/products/inventory/inventory-received.png',
      '/images/products/inventory/inventory-received-form.png',
      '/images/products/inventory/inventory-transfers.png',
      '/images/products/inventory/inventory-transfer-form.png',
      '/images/products/inventory/inventory-adjustments.png',
      '/images/products/inventory/inventory-adjustment-form.png',
      '/images/products/inventory/inventory-withdrawals.png',
      '/images/products/inventory/inventory-withdrawal-form.png',
      '/images/products/inventory/inventory-balances.png',
      '/images/products/inventory/inventory-reports.png',
    ],
    backgroundImage: '/images/products/inventory/inventory-items.png',
    highlights: [
      'បញ្ជាទិញ → ការទទួលទំនិញ → សមតុល្យនៅដៃ',
      'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុកក្រុមហ៊ុន',
      'ស្តុកត្រូវដកពេលទំនិញស្តុកត្រូវចេញវិក្កយបត្រ',
      'សំណើដកស្តុកតាមសេវាកម្មបុគ្គលិកដោយខ្លួនឯង',
    ],
    workflow: {
      title: 'ទិញ រក្សាទុក លក់',
      path: 'Purchase order → Receive → Sell (invoice) → Verify balances',
      steps: [
        {
          title: 'បញ្ជាទិញពីអ្នកផ្គត់ផ្គង់',
          description: 'ដាក់បញ្ជាទិញលើទំនិញស្តុក ជាមួយអ្នកផ្គត់ផ្គង់ពី Expenses។',
        },
        {
          title: 'ទទួលចូលទីតាំង',
          description: 'កត់ត្រាការទទួលទំនិញចូលឃ្លាំង ឬហាង។ បរិមាណនៅដៃកើនឡើង។',
        },
        {
          title: 'ផ្ទេរ កែតម្រូវ ឬដក',
          description:
            'ផ្ទេររវាងទីតាំង កែតម្រូវក្រោយរាប់ស្តុក ឬចេញការដកស្តុកក្រុមហ៊ុន (រួមទាំងសំណើពីសេវាកម្មបុគ្គលិកដោយខ្លួនឯង)។',
        },
        {
          title: 'លក់ និងពិនិត្យសមតុល្យ',
          description: 'វិក្កយបត្រក្នុងការគ្រប់គ្រងចំណូល ដកស្តុក។ សមតុល្យស្តុកបញ្ជាក់ថាអ្វីនៅសល់។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ទំនិញស្តុកដែលតាមដានបរិមាណ',
          'ទីតាំង (ឃ្លាំង និងហាង) ពី Administration',
          'អ្នកផ្គត់ផ្គង់ចែករំលែកជាមួយ Expenses',
          'ប្រភេទទំនិញ ជាមួយការកំណត់គណនី GL តាមជម្រើស',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'បញ្ជាទិញ និងការទទួលទំនិញ',
          'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុកក្រុមហ៊ុន',
          'សមតុល្យស្តុក',
          'របាយការណ៍ស្តុក',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '📦',
        title: 'ស្តុកច្រើនទីតាំង',
        description:
          'តាមដានបរិមាណនៅដៃតាមឃ្លាំង ឬហាង។ ទីតាំងជាកំណត់ត្រាដូចគ្នាដែលប្រើក្នុង ERP ទាំងមូល មិនមែនជាកម្មវិធីឃ្លាំងដាច់ដោយឡែកទេ។',
        images: [
          '/images/products/inventory/inventory-items.png',
          '/images/products/inventory/inventory-item-form.png',
          '/images/products/inventory/inventory-balances.png',
        ],
      },
      {
        icon: '🧾',
        title: 'ការទិញ និងការទទួលទំនិញ',
        description:
          'ចេញបញ្ជាទិញ បន្ទាប់មកទទួលទំនិញចូលទីតាំង។ វិក្កយបត្រទិញក្នុង Expenses អាចតាមការទទួល។',
        images: [
          '/images/products/inventory/inventory-purchase-orders.png',
          '/images/products/inventory/inventory-purchase-order-form.png',
          '/images/products/inventory/inventory-received.png',
          '/images/products/inventory/inventory-received-form.png',
        ],
      },
      {
        icon: '🔄',
        title: 'ការផ្ទេរ ការកែតម្រូវ ការដកស្តុក',
        description:
          'ផ្ទេរស្តុករវាងទីតាំង កែតម្រូវក្រោយរាប់ ឬចេញការដកស្តុកក្រុមហ៊ុន។ បុគ្គលិកអាចស្នើសុំដកស្តុកពីសេវាកម្មបុគ្គលិកដោយខ្លួនឯង។ បុគ្គលិកឃ្លាំងបំពេញសំណើដែលបានអនុម័ត។',
        images: [
          '/images/products/inventory/inventory-transfers.png',
          '/images/products/inventory/inventory-transfer-form.png',
          '/images/products/inventory/inventory-adjustments.png',
          '/images/products/inventory/inventory-adjustment-form.png',
          '/images/products/inventory/inventory-withdrawals.png',
          '/images/products/inventory/inventory-withdrawal-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'សមតុល្យ និងរបាយការណ៍',
        description:
          'ពិនិត្យបរិមាណនៅដៃក្រោយទទួល ផ្ទេរ និងលក់។ របាយការណ៍ស្តុកបង្ហាញចលនា និងស្តុកនៅសល់។',
        images: [
          '/images/products/inventory/inventory-balances.png',
          '/images/products/inventory/inventory-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS Inventory | បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ និងសមតុល្យ',
      description:
        'AKAS Inventory គ្រប់គ្រងទំនិញស្តុក បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ ការកែតម្រូវ ការដកស្តុកក្រុមហ៊ុន និងសមតុល្យតាមទីតាំង។',
      keywords: 'ស្តុក, ឃ្លាំង, បញ្ជាទិញ, ការផ្ទេរស្តុក, សមតុល្យស្តុក, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🛒',
        title: 'តភ្ជាប់ជាមួយការលក់',
        description: 'ការចេញវិក្កយបត្រទំនិញស្តុកក្នុងការគ្រប់គ្រងចំណូល ដកស្តុកដោយស្វ័យប្រវត្តិ។',
      },
      {
        icon: '💻',
        title: 'ការដកស្តុកតាមសេវាកម្មបុគ្គលិកដោយខ្លួនឯង',
        description: 'បុគ្គលិកស្នើសុំស្តុកពី Dashboard → Self Service → Inventory Withdrawal Request។',
      },
      {
        icon: '🔔',
        title: 'ការអនុម័ត និងកំណត់ត្រា',
        description: 'ចលនាអាចទាមទារការអនុម័ត។ កំណត់ត្រាទិន្នន័យបង្ហាញថាអ្នកណាបានផ្លាស់ប្តូរស្តុក។',
      },
      {
        icon: '🏪',
        title: 'ការលក់តាមបញ្ជរ និងហាងអនឡាញ',
        description: 'ទំនិញ និងទីតាំងដូចគ្នា ផ្គត់ផ្គង់ ការលក់តាមបញ្ជរ និងហាងអនឡាញ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ដឹងថាអ្វីនៅដៃ',
        description:
          'សមតុល្យធ្វើបច្ចុប្បន្នភាពពីការទទួល ផ្ទេរ ការដកស្តុកក្រុមហ៊ុន និងការលក់ — មិនមែនពីការរាប់ម្តងក្នុងមួយសប្តាហ៍ប៉ុណ្ណោះទេ។',
      },
      {
        number: '02',
        title: 'ការទិញមានផ្លូវដាន',
        description: 'បញ្ជាទិញ និងការទទួលទំនិញស្ថិតក្បែរវិក្កយបត្រទិញ ជំនួសឧបករណ៍ទិញដាច់ដោយឡែក។',
      },
      {
        number: '03',
        title: 'ខ្វះស្តុកភ្លាមៗមានតិច',
        description: 'ការលក់ដកទំនិញស្តុក ដូច្នេះការលក់បន្ទាប់ក្នុងការលក់តាមបញ្ជរ ឬវិក្កយបត្រ ឃើញចំនួនពិត។',
      },
      {
        number: '04',
        title: 'បុគ្គលិកអាចស្នើសុំស្តុក',
        description:
          'ការដកស្តុកក្រុមហ៊ុនតាមសេវាកម្មបុគ្គលិកដោយខ្លួនឯង ធ្វើឱ្យការប្រើប្រាស់ផ្ទៃក្នុងស្ថិតលើសៀវភៅដូចគ្នានឹងការចេញពីឃ្លាំង។',
      },
    ],
    related: [
      { label: 'Expenses', to: '/products/expenses' },
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើ Inventory', href: `${DOCS_ORIGIN}/en/inventory/` },
    ],
  },
  {
    id: 7,
    slug: 'clinic',
    name: 'ការគ្រប់គ្រងគ្លីនិក',
    shortName: 'Clinic',
    navLabel: 'ការគ្រប់គ្រងគ្លីនិក',
    tagline: 'ជួររង់ចាំ ពិគ្រោះ ចេញវេជ្ជបញ្ជា ចែកឱសថ និងប្រមូលប្រាក់',
    featured: true,
    description:
      'AKAS Clinic Management ដំណើរការពីផ្នែកទទួលភ្ញៀវដល់ការទូទាត់៖ ជួររង់ចាំ ការណាត់ជួប កំណត់ត្រាសុខភាពអេឡិចត្រូនិក ការពិគ្រោះ និងវេជ្ជបញ្ជា ស្តុកឱសថស្ថាន វិក្កយបត្រ និងការប្រមូលប្រាក់ KHQR។ វាជាពហុភាសា និងដំណើរការក្នុងកម្មវិធីរុករកលើកុំព្យូទ័រ និងថេប្លេតគ្លីនិក។',
    images: [
      '/images/products/clinic-queue.png',
      '/images/products/clinic-appointment.png',
      '/images/products/clinic-consultation.png',
      '/images/products/clinic-prescription.png',
      '/images/products/clinic-dispensary.png',
      '/images/products/clinic-payment.png',
      '/images/products/clinic-dashboard.png',
    ],
    backgroundImage: '/images/products/clinic-bg.gif',
    highlights: [
      'ការគ្រប់គ្រងជួររង់ចាំ និងការណាត់ជួប',
      'ការពិគ្រោះ វេជ្ជបញ្ជា និង EHR',
      'ស្តុកឱសថស្ថាន',
      'វិក្កយបត្រជាមួយការទូទាត់ KHQR',
    ],
    workflow: {
      title: 'ការមកពិគ្រោះអ្នកជំងឺ',
      path: 'Queue / appointment → Consult → Prescribe → Dispense → Pay',
      steps: [
        {
          title: 'មកដល់',
          description: 'ដាក់អ្នកជំងឺចូលជួររង់ចាំ ឬគោរពតាមការណាត់ជួបដែលបានកក់។',
        },
        {
          title: 'ពិគ្រោះ និងកត់ត្រា',
          description: 'កត់ត្រាការមកពិគ្រោះក្នុងកំណត់ត្រាអេឡិចត្រូនិក និងចេញវេជ្ជបញ្ជា។',
        },
        {
          title: 'ចែកឱសថ',
          description: 'ចេញឱសថពីស្តុកឱសថស្ថាន ជាមួយផ្លូវដានចលនា។',
        },
        {
          title: 'ប្រមូលប្រាក់',
          description: 'ចេញវិក្កយបត្រការមកពិគ្រោះ និងទទួលការទូទាត់ រួមទាំង KHQR។',
        },
      ],
    },
    mainFeatures: [
      {
        icon: '💻',
        title: 'ការគ្រប់គ្រងជួររង់ចាំ',
        description:
          'តាមដានអ្នករង់ចាំតាមពេលវេលាជាក់ស្តែង ដូច្នេះជាន់អាចហៅអ្នកជំងឺបន្ទាប់ ដោយមិនចាំបាច់ស្រែកឆ្លងបន្ទប់រង់ចាំ។',
        images: ['/images/products/clinic-queue.png'],
      },
      {
        icon: '📅',
        title: 'ការណាត់ជួប',
        description:
          'កក់ការមកពិគ្រោះ មើលថ្ងៃទាំងមូលក្នុងមួយភ្លែត និងភ្ជាប់ការណាត់ជួបទៅកំណត់ត្រាអ្នកជំងឺពេលគេមកដល់។',
        images: ['/images/products/clinic-appointment.png'],
      },
      {
        icon: '📊',
        title: 'កំណត់ត្រាសុខភាពអេឡិចត្រូនិក',
        description:
          'រក្សារោគវិនិច្ឆ័យ ការព្យាបាល ឱសថ និងប្រវត្តិការមកពិគ្រោះលើអ្នកជំងឺ — អ្នកព្យាបាលបន្ទាប់ដែលបើកឯកសារអាចមើលបាន។',
        images: ['/images/products/clinic-ehr.png'],
      },
      {
        icon: '🩺',
        title: 'ការពិគ្រោះ និងវេជ្ជបញ្ជា',
        description:
          'កត់ត្រាការពិគ្រោះ និងចេញវេជ្ជបញ្ជាដែលឱសថស្ថានអាចបំពេញបាន ដោយមិនវាយឈ្មោះឱសថ និងកម្រិតឡើងវិញ។',
        images: [
          '/images/products/clinic-consultation.png',
          '/images/products/clinic-prescription.png',
        ],
      },
      {
        icon: '💊',
        title: 'ការគ្រប់គ្រងឱសថស្ថាន',
        description: 'រក្សាស្តុកឱសថគ្លីនិកឱ្យទាន់សម័យ៖ ការចេញ ការកែតម្រូវ និងផ្លូវដាននៃអ្វីដែលចេញពីធ្នើ។',
        images: ['/images/products/clinic-dispensary.png'],
      },
      {
        icon: '💳',
        title: 'វិក្កយបត្រ និងការទូទាត់',
        description:
          'បង្កើតវិក្កយបត្រ និងបង្កាន់ដៃសម្រាប់ការពិគ្រោះ និងការព្យាបាល ហើយប្រមូលប្រាក់តាមវិធីដូចជា KHQR។',
        images: ['/images/products/clinic-payment.png'],
      },
    ],
    meta: {
      title: 'AKAS Clinic Management | ជួររង់ចាំ EHR ឱសថស្ថាន និងវិក្កយបត្រ KHQR',
      description:
        'AKAS Clinic Management គ្របដណ្តប់ជួររង់ចាំ ការណាត់ជួប កំណត់ត្រាអេឡិចត្រូនិក វេជ្ជបញ្ជា ស្តុកឱសថស្ថាន វិក្កយបត្រ និងការទូទាត់ KHQR។',
      keywords: 'ការគ្រប់គ្រងគ្លីនិក, EHR, ការណាត់ជួប, ឱសថស្ថាន, KHQR គ្លីនិក, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ផ្នែកទទួលភ្ញៀវ និងអ្នកព្យាបាលអាចធ្វើការជាភាសាណាមួយ។',
      },
      {
        icon: '📁',
        title: 'ការគ្រប់គ្រងឯកសារ',
        description: 'រក្សាកំណត់ចំណាំការមកពិគ្រោះ ឯកសារ និងប្រវត្តិលើកំណត់ត្រាអ្នកជំងឺ។',
      },
      {
        icon: '⚙️',
        title: 'កែតម្រូវបាន',
        description: 'បន្ថែមវាល និងរបាយការណ៍តាមរបៀបដែលគ្លីនិករបស់អ្នកដំណើរការពិតប្រាកដ។',
      },
      {
        icon: '🔔',
        title: 'ការជូនដំណឹងផ្ទាល់',
        description: 'ព្រឹត្តិការណ៍ជួររង់ចាំ ការណាត់ជួប និងស្តុក បង្ហាញភ្លាមៗពេលកើតឡើង។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'រង់ចាំខ្លីជាង',
        description: 'ជួររង់ចាំ និងការណាត់ជួប ផ្តល់ប្រភពតែមួយថាអ្នកណាបន្ទាប់។',
      },
      {
        number: '02',
        title: 'ឯកសារអ្នកជំងឺតែមួយ',
        description: 'ការពិគ្រោះ វេជ្ជបញ្ជា និងការចេញឱសថ ស្ថិតលើការមកពិគ្រោះតែមួយ។',
      },
      {
        number: '03',
        title: 'ស្តុកដែលត្រូវនឹងវេជ្ជបញ្ជា',
        description: 'ចលនាឱសថស្ថានដើរតាមវេជ្ជបញ្ជា ជំនួសសៀវភៅកត់ត្រាក្បែរ។',
      },
      {
        number: '04',
        title: 'ប្រមូលប្រាក់មុនពេលគេចេញ',
        description: 'វិក្កយបត្រ និងការទូទាត់ KHQR បិទការមកពិគ្រោះ ដោយមិនចាំបាច់ប្រព័ន្ធគ្រឿងគិតលុយដាច់ដោយឡែក។',
      },
    ],
    related: [
      { label: 'Demo គ្លីនិកផ្ទាល់', to: '/demo' },
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
    ],
  },
  {
    id: 8,
    slug: 'pos',
    name: 'ការលក់តាមបញ្ជរ (POS)',
    shortName: 'POS',
    navLabel: 'ការលក់តាមបញ្ជរ (POS)',
    tagline: 'គ្រឿងគិតលុយហាង និងភោជនីយដ្ឋាន លើ Windows, macOS និង Android',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/pos/`,
    description:
      'ការលក់តាមបញ្ជរ ត្រូវបានបង្កើតសម្រាប់ការលក់រាយប្រចាំថ្ងៃ (Mart) និងប្រតិបត្តិការភោជនីយដ្ឋាន។ អ្នកគិតលុយចូល ជ្រើសរើសរបៀប និងលក់៖ ស្វែងរក ឬស្កេនទំនិញ ទទួលការទូទាត់ និងបោះពុម្ព។ របៀបភោជនីយដ្ឋានបន្ថែមជាន់ តុ បញ្ជា និងការបោះពុម្ពផ្ទះបាយ។ ស្តុក តម្លៃ និងទំនិញមកពីបញ្ជីដូចគ្នានឹងការគ្រប់គ្រងចំណូល និង Inventory ដូច្នេះការលក់នៅគ្រឿងគិតលុយ មិនមែនជាកោះទិន្នន័យដាច់ដោយឡែកទេ។',
    images: [
      '/images/products/pos/pos-login.png',
      '/images/products/pos/pos-mart-main.png',
      '/images/products/pos/pos-mart-checkout.png',
      '/images/products/pos/pos-mart-checkout-final.png',
      '/images/products/pos/pos-rest.png',
      '/images/products/pos/pos-rest-main.png',
      '/images/products/pos/pos-rest-floor.png',
      '/images/products/pos/pos-rest-floor-create.png',
      '/images/products/pos/pos-rest-table-create.png',
      '/images/products/pos/pos-rest-table-move-resize.png',
      '/images/products/pos/pos-rest-order.png',
      '/images/products/pos/pos-rest-order-2.png',
      '/images/products/pos/pos-rest-checkout.png',
      '/images/products/pos/pos-rest-checkout-complete.png',
      '/images/products/pos/pos-rest-order-kitchen-print.png',
      '/images/products/pos/pos-rest-order-kitchen-print-2.png',
      '/images/products/pos/pos-rest-order-kitchen-reprint.png',
    ],
    backgroundImage: '/images/products/pos/pos-mart-main.png',
    highlights: [
      'របៀប Mart៖ បញ្ជីទំនិញ បាកូដ checkout ការទូទាត់',
      'របៀបភោជនីយដ្ឋាន៖ ជាន់ តុ បោះពុម្ពផ្ទះបាយ ការទូទាត់',
      'កម្មវិធីដើមសម្រាប់ Windows, macOS និង Android',
      'ទំនិញ និងស្តុកចែករំលែកជាមួយ Inventory និង ការគ្រប់គ្រងចំណូល',
    ],
    workflow: {
      title: 'ធ្វើការលក់',
      path: 'Login → Mart or Restaurant → Add items / table order → Checkout → Payment',
      steps: [
        {
          title: 'ចូល និងជ្រើសរើសរបៀប',
          description: 'បើកការលក់តាមបញ្ជរ ហើយជ្រើសរើស Mart (លក់រាយ) ឬភោជនីយដ្ឋានសម្រាប់វេន។',
        },
        {
          title: 'បង្កើតបញ្ជីលក់',
          description:
            'Mart៖ ស្វែងរក ស្កេន និងបន្ថែមទំនិញពីបញ្ជី។ ភោជនីយដ្ឋាន៖ អង្គុយតុ កត់បញ្ជា បោះពុម្ពទៅផ្ទះបាយ។',
        },
        {
          title: 'Checkout',
          description: 'ពិនិត្យសរុប ពន្ធ និងការទូទាត់។ បញ្ចប់ការទូទាត់ និងចេញបង្កាន់ដៃ។',
        },
        {
          title: 'ស្តុក និងសៀវភៅគណនេយ្យដើរតាម',
          description: 'ទំនិញដែលលក់ធ្វើបច្ចុប្បន្នភាពស្តុក និងចូលកំណត់ត្រាចំណូលដែលគណនេយ្យប្រើ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'Mart (លក់រាយ)',
        items: [
          'ស្វែងរកក្បាលទំព័រ និងស្កេនបាកូដ',
          'តម្រងប្រភេទ និងផ្ទាំងទំនិញ',
          'ផ្ទាំងការលក់បច្ចុប្បន្ន ជាមួយពន្ធ និងសរុប',
          'Checkout លឿន — គ្រាប់ចុចខ្លីជួយអ្នកគិតលុយឆ្លងកាត់ជួររង់ចាំ',
        ],
      },
      {
        title: 'ភោជនីយដ្ឋាន',
        items: [
          'ផែនការជាន់ និងតុមើលឃើញ — បន្ថែមជាន់ ដាក់តុតាមទីតាំងពិត',
          'បញ្ជាតុ ជាមួយការបោះពុម្ពផ្ទះបាយ។ ការបោះពុម្ពឡើងវិញមានតែទំនិញថ្មី ដូច្នេះផ្ទះបាយមិនចម្អិនបញ្ជាពីរដងទេ',
          'បោះពុម្ពបញ្ជីពេញលេញ នៅពេលបង្កាន់ដៃបាត់',
          'Checkout និងការទូទាត់នៅតុ ឬគ្រឿងគិតលុយ ជាមួយកូប៉ុន និងពន្ធលើបង្កាន់ដៃ',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '🖥️',
        title: 'កម្មវិធីច្រើនប្រព័ន្ធ',
        description:
          'ដំណើរការ AKAS ការលក់តាមបញ្ជរ លើគ្រឿងគិតលុយ Windows ទូរអ្នកលក់ Mac និងថេប្លេត Android ជាមួយលំហូរ checkout ដូចគ្នា។',
        images: ['/images/products/pos/pos-login.png'],
      },
      {
        icon: '🛒',
        title: 'Checkout Mart',
        description:
          'រកទំនិញ ស្កេនបាកូដ បន្ថែមចូលការលក់ និងបញ្ចប់ការទូទាត់។ អេក្រង់បែងចែកជាការស្វែងរក បញ្ជីទំនិញ និងបញ្ជីលក់បច្ចុប្បន្ន។',
        images: [
          '/images/products/pos/pos-mart-main.png',
          '/images/products/pos/pos-mart-checkout.png',
          '/images/products/pos/pos-mart-checkout-final.png',
        ],
      },
      {
        icon: '🍽️',
        title: 'សេវាភោជនីយដ្ឋាន',
        description:
          'គ្រប់គ្រងជាន់ និងតុ កត់បញ្ជា បោះពុម្ពទៅផ្ទះបាយ បោះពុម្ពឡើងវិញពេលបញ្ជីបាត់ និងទទួលការទូទាត់។',
        images: [
          '/images/products/pos/pos-rest.png',
          '/images/products/pos/pos-rest-main.png',
          '/images/products/pos/pos-rest-floor.png',
          '/images/products/pos/pos-rest-floor-create.png',
          '/images/products/pos/pos-rest-table-create.png',
          '/images/products/pos/pos-rest-table-move-resize.png',
          '/images/products/pos/pos-rest-order.png',
          '/images/products/pos/pos-rest-order-2.png',
          '/images/products/pos/pos-rest-checkout.png',
          '/images/products/pos/pos-rest-checkout-complete.png',
          '/images/products/pos/pos-rest-order-kitchen-print.png',
          '/images/products/pos/pos-rest-order-kitchen-print-2.png',
          '/images/products/pos/pos-rest-order-kitchen-reprint.png',
        ],
      },
      {
        icon: '📦',
        title: 'ធ្វើសមកាលកម្មស្តុក',
        description:
          'ទំនិញដែលលក់មកពីបញ្ជីចែករំលែក។ ស្តុកចលនាជាមួយការលក់ ដូច្នេះការិយាល័យខាងក្រោយ និងជាន់លក់ឃើញដូចគ្នា។',
      },
    ],
    meta: {
      title: 'AKAS ការលក់តាមបញ្ជរ | គ្រឿងគិតលុយហាង និងភោជនីយដ្ឋាន',
      description:
        'AKAS ការលក់តាមបញ្ជរ គាំទ្រ checkout លក់រាយ Mart និងសេវាតុភោជនីយដ្ឋាន ជាមួយការបោះពុម្ពផ្ទះបាយ លើ Windows, macOS និង Android ដោយប្រើទំនិញដូចគ្នានឹង Inventory និង ការគ្រប់គ្រងចំណូល។',
      keywords:
        'ការលក់តាមបញ្ជរ, POS, POS ភោជនីយដ្ឋាន, POS លក់រាយ, kitchen print, barcode, Windows POS, Android POS, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'អ្នកគិតលុយអាចធ្វើការជាភាសាណាមួយ។',
      },
      {
        icon: '⚡',
        title: 'ដំណើរការបានពេល offline',
        description: 'លក់បន្តនៅពេលបណ្តាញផ្តាច់ បន្ទាប់មកធ្វើសមកាលកម្មពេលតភ្ជាប់វិញ។',
      },
      {
        icon: '🔌',
        title: 'ឧបករណ៍',
        description: 'ភ្ជាប់ម៉ាស៊ីនស្កេន ម៉ាស៊ីនបោះពុម្ពបង្កាន់ដៃ និងថតលុយ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ប្រើឧបករណ៍ដែលអ្នកមាន',
        description: 'Windows, macOS ឬ Android — មិនបង្ខំឱ្យប្តូរគ្រឿងគិតលុយទេ។',
      },
      {
        number: '02',
        title: 'លក់រាយ និង F&B ក្នុងផលិតផលតែមួយ',
        description: 'របៀប Mart និងភោជនីយដ្ឋានចែករំលែកការចូល ទំនិញ និងការទូទាត់ ជំនួសអ្នកផ្គត់ផ្គង់ពីរ។',
      },
      {
        number: '03',
        title: 'ផ្ទះបាយឮបញ្ជា',
        description: 'ការបោះពុម្ព និងបោះពុម្ពឡើងវិញ រក្សាផ្ទះបាយឱ្យដើរទៅមុខ។',
      },
      {
        number: '04',
        title: 'គ្រឿងគិតលុយជាផ្នែកនៃ ERP',
        description: 'ការលក់ចូលស្តុក និងចំណូល មិនមែនចូល Excel ក្បែរនៅចុងថ្ងៃទេ។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'Inventory', to: '/products/inventory' },
      { label: 'ហាងអនឡាញ', to: '/products/online-store' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើការលក់តាមបញ្ជរ', href: `${DOCS_ORIGIN}/en/pos/` },
    ],
  },
  {
    id: 9,
    slug: 'accounting',
    name: 'គណនេយ្យ',
    shortName: 'Accounting',
    navLabel: 'គណនេយ្យ',
    tagline: 'សៀវភៅគណនីទូទៅ បញ្ជីប្រតិបត្តិការ ថវិកា និងរបាយការណ៍ហិរញ្ញវត្ថុ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/accounting/`,
    description:
      'គណនេយ្យគឺជាសៀវភៅគណនីទូទៅរបស់ AKAS។ អ្នករៀបចំតារាងគណនី បញ្ជីប្រតិបត្តិការ ឆ្នាំសារពើពន្ធ និងការភ្ជាប់ GL។ វិក្កយបត្រ វិក្កយបត្រទិញ បង្កាន់ដៃ និងការទូទាត់ដែលបានអនុម័តពីការគ្រប់គ្រងចំណូល និង Expenses ចុះបញ្ជីប្រតិបត្តិការ។ គណនេយ្យករពិនិត្យ ឬបញ្ចូលបញ្ជីប្រតិបត្តិការដោយដៃ បន្ទាប់មកដំណើរការរបាយការណ៍ចំណេញខាត តារាងតុល្យការ លំហូរសាច់ប្រាក់ សមតុល្យសាកល្បង និងថវិកាផ្ទឹមនឹងការប្រើពិត។ ធាតុម៉ឺនុយដើរតាមសិទ្ធិតួនាទី។ បំពេញឆ្នាំសារពើពន្ធ និងអង្គភាពក្នុងការរៀបចំ មុនពេលចុះបញ្ជី។',
    images: [
      '/images/products/accounting/accounting-coa.png',
      '/images/products/accounting/accounting-coa-form.png',
      '/images/products/accounting/accounting-journals.png',
      '/images/products/accounting/accounting-journal-form.png',
      '/images/products/accounting/accounting-journal-entries.png',
      '/images/products/accounting/accounting-journal-entry-form.png',
      '/images/products/accounting/accounting-journal-mappings.png',
      '/images/products/accounting/accounting-journal-mapping-form.png',
      '/images/products/accounting/accounting-txn-mappings.png',
      '/images/products/accounting/accounting-budgets.png',
      '/images/products/accounting/accounting-budget-form.png',
      '/images/products/accounting/accounting-budget-vs-actual.png',
      '/images/products/accounting/accounting-income-statement.png',
      '/images/products/accounting/accounting-balance-sheet.png',
      '/images/products/accounting/accounting-cash-flow.png',
      '/images/products/accounting/accounting-trial-balance.png',
    ],
    backgroundImage: '/images/products/accounting/accounting-coa.png',
    highlights: [
      'តារាងគណនី បញ្ជីប្រតិបត្តិការ និងថវិកា',
      'ការភ្ជាប់ GL ពីវិក្កយបត្រ វិក្កយបត្រទិញ និងការទូទាត់',
      'របាយការណ៍ចំណេញខាត តារាងតុល្យការ លំហូរសាច់ប្រាក់ សមតុល្យសាកល្បង',
      'ថវិកាផ្ទឹមនឹងការប្រើពិត',
    ],
    workflow: {
      title: 'បិទសៀវភៅគណនេយ្យពីប្រតិបត្តិការ',
      path: 'Chart of accounts → GL mappings → Operational posting → Statements',
      steps: [
        {
          title: 'រៀបចំរចនាសម្ព័ន្ធសៀវភៅ',
          description: 'បង្កើតតារាងគណនី និងកំណត់បញ្ជីប្រតិបត្តិការ ឆ្នាំសារពើពន្ធ និងថវិកា។',
        },
        {
          title: 'ភ្ជាប់ប្រតិបត្តិការ',
          description: 'ប្រាប់ AKAS ថាវិក្កយបត្រ វិក្កយបត្រទិញ បង្កាន់ដៃ និងការទូទាត់ គួរចូលគណនី GL ណា។',
        },
        {
          title: 'ដំណើរការ',
          description: 'ការគ្រប់គ្រងចំណូល និង Expenses ចុះបញ្ជីប្រតិបត្តិការពេលឯកសារទទួលការអនុម័ត។',
        },
        {
          title: 'ពិនិត្យ និងធ្វើរបាយការណ៍',
          description:
            'ពិនិត្យបញ្ជីប្រតិបត្តិការ បន្ថែមការកែតម្រូវដោយដៃ បន្ទាប់មកដំណើរការរបាយការណ៍ហិរញ្ញវត្ថុ និងថវិកាផ្ទឹមនឹងការប្រើពិត។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'តារាងគណនី',
          'បញ្ជីប្រតិបត្តិការ',
          'ថវិកា',
          'ការភ្ជាប់គណនី GL សម្រាប់ឯកសារប្រតិបត្តិការ',
          'ការភ្ជាប់បញ្ជីប្រតិបត្តិការ GL',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'បញ្ជីប្រតិបត្តិការ (ពិនិត្យការចុះបញ្ជីពីប្រតិបត្តិការ និងបញ្ចូលការកែតម្រូវ)',
          'របាយការណ៍ចំណេញខាត',
          'តារាងតុល្យការ',
          'របាយការណ៍លំហូរសាច់ប្រាក់',
          'សមតុល្យសាកល្បង',
          'ថវិកាផ្ទឹមនឹងការប្រើពិត',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '📒',
        title: 'តារាងគណនី និងបញ្ជីប្រតិបត្តិការ',
        description:
          'កំណត់រចនាសម្ព័ន្ធគណនី និងបញ្ជីប្រតិបត្តិការដែលធាតុចុះចូល។ ឆ្នាំសារពើពន្ធ និងអង្គភាពក្នុង Administration កំណត់ពេលចុះបញ្ជីបាន។',
        images: [
          '/images/products/accounting/accounting-coa.png',
          '/images/products/accounting/accounting-coa-form.png',
          '/images/products/accounting/accounting-journals.png',
          '/images/products/accounting/accounting-journal-form.png',
        ],
      },
      {
        icon: '🔗',
        title: 'ការភ្ជាប់ GL',
        description:
          'ភ្ជាប់វិក្កយបត្រ វិក្កយបត្រទិញ បង្កាន់ដៃ និងការទូទាត់ទៅគណនី ដូច្នេះប្រតិបត្តិការចុះសៀវភៅ ជំនួសឱ្យហិរញ្ញវត្ថុវាយឡើងវិញ។',
        images: [
          '/images/products/accounting/accounting-journal-mappings.png',
          '/images/products/accounting/accounting-journal-mapping-form.png',
          '/images/products/accounting/accounting-txn-mappings.png',
        ],
      },
      {
        icon: '✍️',
        title: 'បញ្ជីប្រតិបត្តិការ',
        description:
          'ពិនិត្យធាតុដែលចុះស្វ័យប្រវត្តិ និងបង្កើតការកែតម្រូវដោយដៃ នៅពេលត្រូវការបញ្ជីប្រតិបត្តិការកែតម្រូវ។',
        images: [
          '/images/products/accounting/accounting-journal-entries.png',
          '/images/products/accounting/accounting-journal-entry-form.png',
        ],
      },
      {
        icon: '📈',
        title: 'របាយការណ៍ហិរញ្ញវត្ថុ',
        description:
          'របាយការណ៍ចំណេញខាត តារាងតុល្យការ លំហូរសាច់ប្រាក់ សមតុល្យសាកល្បង និងថវិកាផ្ទឹមនឹងការប្រើពិត — ពីសៀវភៅដូចគ្នាដែលម៉ូឌុលប្រតិបត្តិការចុះបញ្ជី។',
        images: [
          '/images/products/accounting/accounting-income-statement.png',
          '/images/products/accounting/accounting-balance-sheet.png',
          '/images/products/accounting/accounting-cash-flow.png',
          '/images/products/accounting/accounting-trial-balance.png',
          '/images/products/accounting/accounting-budget-vs-actual.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS Accounting | សៀវភៅគណនីទូទៅ បញ្ជីប្រតិបត្តិការ និងរបាយការណ៍ហិរញ្ញវត្ថុ',
      description:
        'AKAS Accounting គ្រប់គ្រងតារាងគណនី ការភ្ជាប់ GL បញ្ជីប្រតិបត្តិការ ថវិកា និងរបាយការណ៍ រួមទាំងចំណេញខាត តារាងតុល្យការ លំហូរសាច់ប្រាក់ និងសមតុល្យសាកល្បង។',
      keywords:
        'គណនេយ្យ, សៀវភៅគណនីទូទៅ, របាយការណ៍ចំណេញខាត, តារាងតុល្យការ, លំហូរសាច់ប្រាក់, សមតុល្យសាកល្បង, AKAS ERP',
    },
    additionalFeatures: [
      {
        icon: '🏢',
        title: 'អង្គភាព និងឆ្នាំសារពើពន្ធ',
        description: 'ស្ថាប័នច្បាប់ អង្គភាព និងឆ្នាំសារពើពន្ធពី Administration មុនពេលចុះបញ្ជី។',
      },
      {
        icon: '🔒',
        title: 'សិទ្ធិតួនាទី',
        description: 'ម៉ឺនុយរបាយការណ៍ និងបញ្ជីប្រតិបត្តិការ បង្ហាញតាមតួនាទីរបស់អ្នកប្រើ។',
      },
      {
        icon: '🏗️',
        title: 'ទ្រព្យសកម្ម',
        description: 'ការរំលស់ចុះបញ្ជីទៅសៀវភៅដូចគ្នា នៅពេលថ្នាក់ទ្រព្យត្រូវបានភ្ជាប់។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ក្រុមហិរញ្ញវត្ថុអាចធ្វើការជាភាសាណាមួយ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'មិនចាំបាច់កត់ពីរដងពីប្រតិបត្តិការ',
        description: 'ការលក់ និងគណនីត្រូវបង់ដែលបានភ្ជាប់ ចុះបញ្ជីប្រតិបត្តិការពេលឯកសារទទួលការអនុម័ត។',
      },
      {
        number: '02',
        title: 'របាយការណ៍ពីសៀវភៅតែមួយ',
        description: 'P&L តារាងតុល្យការ និងលំហូរសាច់ប្រាក់ គឺទិដ្ឋភាពនៃបញ្ជីប្រតិបត្តិការដូចគ្នា។',
      },
      {
        number: '03',
        title: 'ថវិកាដែលប្រៀបធៀបបាន',
        description: 'ថវិកាផ្ទឹមនឹងការប្រើពិត គឺជារបាយការណ៍ផ្ទាល់ មិនមែននាំចេញ Excel ទេ។',
      },
      {
        number: '04',
        title: 'ការកែតម្រូវមានផ្លូវដាន',
        description: 'បញ្ជីប្រតិបត្តិការដោយដៃស្ថិតក្បែរការចុះបញ្ជីពីប្រតិបត្តិការ ជាមួយអ្នកប្រើ និងពេលវេលា។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'Expenses', to: '/products/expenses' },
      { label: 'ទ្រព្យសកម្ម', to: '/products/fixed-assets' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើ Accounting', href: `${DOCS_ORIGIN}/en/accounting/` },
    ],
  },
  {
    id: 10,
    slug: 'fixed-assets',
    name: 'ទ្រព្យសកម្ម',
    shortName: 'Fixed Assets',
    navLabel: 'ទ្រព្យសកម្ម',
    tagline: 'ចុះបញ្ជីទ្រព្យ ចាត់ថ្នាក់ និងចុះការរំលស់',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/fixed-assets/`,
    description:
      'ទ្រព្យសកម្មគ្រប់គ្រងទ្រព្យរយៈពេលវែង និងការរំលស់។ កំណត់ថ្នាក់ទ្រព្យជាមួយអាយុកាលប្រើប្រាស់ ចុះបញ្ជីទ្រព្យនីមួយៗ (ជាមួយទីតាំង និងអ្នកផ្គត់ផ្គង់នៅពេលពាក់ព័ន្ធ) បន្ទាប់មកគណនាការរំលស់តាមកាលកំណត់ចូលសៀវភៅគណនីទូទៅ។ គួររៀបចំតារាងគណនីក្នុងគណនេយ្យ មុនពេលចុះការរំលស់។',
    images: [
      '/images/products/fixed-assets/fa-asset-classes.png',
      '/images/products/fixed-assets/fa-asset-class-form.png',
      '/images/products/fixed-assets/fa-assets.png',
      '/images/products/fixed-assets/fa-asset-form.png',
      '/images/products/fixed-assets/fa-depreciation.png',
      '/images/products/fixed-assets/fa-reports.png',
    ],
    backgroundImage: '/images/products/fixed-assets/fa-assets.png',
    highlights: [
      'ថ្នាក់ទ្រព្យជាមួយអាយុកាលប្រើប្រាស់',
      'បញ្ជីទ្រព្យជាមួយទីតាំង និងអ្នកផ្គត់ផ្គង់',
      'ការចុះការរំលស់តាមកាលកំណត់',
      'របាយការណ៍ទ្រព្យសកម្ម',
    ],
    workflow: {
      title: 'ដាក់ជាទុន និងរំលស់',
      path: 'Asset class → Register asset → Calculate depreciation',
      steps: [
        {
          title: 'កំណត់ថ្នាក់',
          description: 'កំណត់ប្រភេទ និងអាយុកាលប្រើប្រាស់ ដូច្នេះទ្រព្យស្រដៀងគ្នារំលស់តាមរបៀបដូចគ្នា។',
        },
        {
          title: 'ចុះបញ្ជីទ្រព្យ',
          description: 'កត់ត្រាទ្រព្យនីមួយៗ ទីតាំង និងអ្នកផ្គត់ផ្គង់តាមតម្រូវការ។',
        },
        {
          title: 'ដំណើរការការរំលស់',
          description: 'គណនា និងចុះធាតុការរំលស់តាមកាលកំណត់ទៅសៀវភៅ។',
        },
        {
          title: 'របាយការណ៍',
          description: 'ប្រើរបាយការណ៍ទ្រព្យសកម្មសម្រាប់បញ្ជី និងការរំលស់ប្រមូលផ្តុំ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ទំព័រ',
        items: [
          'ថ្នាក់ទ្រព្យ',
          'បញ្ជីទ្រព្យសកម្ម',
          'គណនាការរំលស់',
          'របាយការណ៍ទ្រព្យសកម្ម',
          'ទីតាំង និងអ្នកផ្គត់ផ្គង់ពីម៉ឺនុយរៀបចំចែករំលែក',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '🏷️',
        title: 'ថ្នាក់ទ្រព្យ',
        description:
          'ដាក់ទ្រព្យជាក្រុមតាមប្រភេទ និងអាយុកាលប្រើប្រាស់ ដូច្នេះគោលនយោបាយការរំលស់មិនស្ថិតលើ Excel ម្នាក់ៗទេ។',
        images: [
          '/images/products/fixed-assets/fa-asset-classes.png',
          '/images/products/fixed-assets/fa-asset-class-form.png',
        ],
      },
      {
        icon: '📋',
        title: 'បញ្ជីទ្រព្យ',
        description:
          'ទ្រព្យនីមួយៗមានអត្តសញ្ញាណ ថ្នាក់ និងទីតាំង/អ្នកផ្គត់ផ្គង់តាមជម្រើស — ទីតាំង និងអ្នកផ្គត់ផ្គង់ដូចគ្នាដែលប្រើកន្លែងផ្សេងក្នុង AKAS។',
        images: [
          '/images/products/fixed-assets/fa-assets.png',
          '/images/products/fixed-assets/fa-asset-form.png',
        ],
      },
      {
        icon: '📉',
        title: 'ការរំលស់',
        description: 'ចុះការរំលស់តាមកាលកំណត់ទៅគណនេយ្យ ជំនួសការកែសៀវភៅដោយដៃនៅចុងឆ្នាំ។',
        images: ['/images/products/fixed-assets/fa-depreciation.png'],
      },
      {
        icon: '📊',
        title: 'របាយការណ៍',
        description: 'របាយការណ៍បញ្ជី និងការរំលស់ សម្រាប់ហិរញ្ញវត្ថុ និងសវនកម្ម។',
        images: ['/images/products/fixed-assets/fa-reports.png'],
      },
    ],
    meta: {
      title: 'AKAS Fixed Assets | បញ្ជីទ្រព្យ ថ្នាក់ និងការរំលស់',
      description:
        'AKAS Fixed Assets គ្រប់គ្រងថ្នាក់ទ្រព្យ បញ្ជីទ្រព្យ ការចុះការរំលស់តាមកាលកំណត់ និងរបាយការណ៍ទ្រព្យសកម្ម។',
      keywords: 'ទ្រព្យសកម្ម, ការរំលស់, បញ្ជីទ្រព្យ, AKAS accounting',
    },
    additionalFeatures: [
      {
        icon: '📒',
        title: 'ចុះបញ្ជីទៅ GL',
        description: 'ធាតុការរំលស់ចូលសៀវភៅដូចគ្នានឹងបញ្ជីប្រតិបត្តិការពីប្រតិបត្តិការ។',
      },
      {
        icon: '📍',
        title: 'ទីតាំងចែករំលែក',
        description: 'ទ្រព្យស្ថិតលើទីតាំង Administration ដែលស្តុកប្រើ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'បញ្ជីជំនួសបញ្ជីឈ្មោះ',
        description: 'ទ្រព្យនីមួយៗជាកំណត់ត្រា ជាមួយថ្នាក់ ទីតាំង និងប្រវត្តិ។',
      },
      {
        number: '02',
        title: 'ការរំលស់តាមកាលវិភាគ',
        description: 'ការគណនាតាមកាលកំណត់ចុះសៀវភៅ។ អ្នកពិនិត្យតែករណីខុសពីធម្មតា។',
      },
      {
        number: '03',
        title: 'ត្រូវនឹងគណនេយ្យ',
        description: 'មិនមានសៀវភៅទ្រព្យដាច់ដោយឡែកត្រូវផ្ទៀងផ្ទាត់នៅពេលបិទគណនីទេ។',
      },
      {
        number: '04',
        title: 'ត្រៀមសម្រាប់សំណួរសវនកម្ម',
        description: 'ថ្នាក់ បញ្ជី និងការរំលស់ដែលបានចុះ ស្ថិតក្នុងម៉ូឌុលតែមួយ។',
      },
    ],
    related: [
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'Expenses', to: '/products/expenses' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើ Fixed Assets', href: `${DOCS_ORIGIN}/en/fixed-assets/` },
    ],
  },
  {
    id: 11,
    slug: 'online-store',
    name: 'ហាងអនឡាញ',
    shortName: 'Online Store',
    navLabel: 'ហាងអនឡាញ',
    tagline: 'ផ្ទាំងហាងលើទំនិញ តម្លៃ និងការទូទាត់ដូចគ្នានឹង ERP',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/online-store/`,
    description:
      'ហាងអនឡាញ AKAS គឺជាបញ្ជីទំនិញដែលអតិថិជនឃើញ រស់នៅ yourbrand.akas.co។ អ្នកកំណត់ព័ត៌មានហាង វិធីទូទាត់ ផ្ទាំងបង្ហាញ ប្រភេទ លក្ខខណ្ឌ និងបណ្តាញសង្គម — បន្ទាប់មកកែសម្រួលផ្ទាំងហាង។ ផលិតផល ស្តុក និងការទូទាត់ គឺជាកំណត់ត្រាដូចគ្នាដែលប្រើក្នុងការគ្រប់គ្រងចំណូល និង Inventory ដូច្នេះការបញ្ជាលើវេបមិនមែនជាមូលដ្ឋានទិន្នន័យទំនិញទីពីរទេ។ Checkout គាំទ្រ Cash on Delivery និង ABA PayWay។ គោលនយោបាយដឹកជញ្ជូនបង្ហាញនៅពេលបើក ecommerce។',
    images: [
      '/images/products/online-store/akas-store-info.png',
      '/images/products/online-store/akas-store-paymethod.png',
      '/images/products/online-store/akas-store-banner-list.png',
      '/images/products/online-store/akas-store-banner-form.png',
      '/images/products/online-store/akas-store-terms.png',
      '/images/products/online-store/akas-store-menu.png',
      '/images/products/online-store/biz-admin-orgchart.png',
      '/images/products/online-store/biz-admin-orgchart-create.png',
      '/images/products/online-store/biz-admin-orgchart-com.png',
    ],
    backgroundImage: '/images/products/online-store/akas-store-info.png',
    highlights: [
      'ផ្ទាំងហាងនៅ yourbrand.akas.co ជាមួយម៉ាក និងផ្ទាំងបង្ហាញរបស់អ្នក',
      'Checkout ជាមួយ ABA PayWay និង Cash on Delivery',
      'ប្រភេទ ផ្ទាំងបង្ហាញ និងលក្ខខណ្ឌកែបាន',
      'បញ្ជីទំនិញ និងស្តុកចែករំលែកជាមួយ ERP',
    ],
    workflow: {
      title: 'បើកហាង',
      path: 'Store info → Payments → Banners & terms → Customize → Sell',
      steps: [
        {
          title: 'ព័ត៌មានហាង',
          description: 'ឈ្មោះ ទំនាក់ទំនង និងអត្តសញ្ញាណផ្ទាំងហាងសម្រាប់អាជីវកម្មរបស់អ្នក។',
        },
        {
          title: 'វិធីទូទាត់',
          description: 'បើកវិធីដែលអតិថិជនអាចប្រើនៅ checkout។',
        },
        {
          title: 'ផ្ទាំងបង្ហាញ និងលក្ខខណ្ឌ',
          description: 'ផ្សាយយុទ្ធនាការ និងលក្ខខណ្ឌដែលអនុវត្ត។',
        },
        {
          title: 'កែសម្រួល និងលក់',
          description: 'កែផ្ទាំងហាង បន្ទាប់មកទទួលបញ្ជាលើបញ្ជីទំនិញផ្ទាល់។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំហាង',
        items: [
          'ព័ត៌មានហាង ជាមួយអត្តសញ្ញាណ ពាក្យស្លោក និងពណ៌ម៉ាក',
          'វិធីទូទាត់ហាង — ABA PayWay និង Cash on Delivery',
          'ផ្ទាំងបង្ហាញ និងទង់ «បង្ហាញក្នុងហាង» តាមប្រភេទ ជាមួយគោលនយោបាយដឹកជញ្ជូន',
          'លក្ខខណ្ឌកែបានដោយអ្នកលក់ ជាមួយឧបករណ៍បង្កើតគំរូ',
          'បណ្តាញសង្គម៖ Telegram, WhatsApp, Facebook, Instagram, TikTok, LinkedIn, X, YouTube',
        ],
      },
      {
        title: 'ការកែសម្រួល',
        items: ['ការកែសម្រួលហាងសម្រាប់ប្លង់ និងម៉ាក'],
      },
    ],
    mainFeatures: [
      {
        icon: '🏪',
        title: 'អត្តសញ្ញាណហាង',
        description: 'កំណត់ហាងសាធារណៈ៖ ព័ត៌មាន ផ្ទាំងបង្ហាញ និងលក្ខខណ្ឌដែលអតិថិជនឃើញមុនពេលទិញ។',
        images: [
          '/images/products/online-store/akas-store-info.png',
          '/images/products/online-store/akas-store-banner-list.png',
          '/images/products/online-store/akas-store-banner-form.png',
          '/images/products/online-store/akas-store-terms.png',
          '/images/products/online-store/akas-store-menu.png',
        ],
      },
      {
        icon: '💳',
        title: 'ការទូទាត់',
        description:
          'Checkout ទទួលការបង់កាតតាម ABA PayWay បង់ពេលទទួលទំនិញ និងវិធីស្កេនបង់ (KHQR) ដែលអ្នកដំណើរការក្នុងការគ្រប់គ្រងចំណូល — ដូច្នេះការបញ្ជាលើវេបចូលសៀវភៅគណនេយ្យដូចគ្នានឹងការលក់ផ្សេងទៀត។',
        images: ['/images/products/online-store/akas-store-paymethod.png'],
      },
      {
        icon: '🎨',
        title: 'ការកែសម្រួល',
        description:
          'កែផ្ទាំងហាង — ម៉ាក ផ្ទាំងបង្ហាញ ប្រភេទ និងលក្ខខណ្ឌ — ដោយមិនចាំបាច់ដំឡើងប្រព័ន្ធ ecommerce ដាច់ដោយឡែក។',
        images: [
          '/images/products/online-store/biz-admin-orgchart.png',
          '/images/products/online-store/biz-admin-orgchart-create.png',
          '/images/products/online-store/biz-admin-orgchart-com.png',
        ],
      },
      {
        icon: '📦',
        title: 'បញ្ជីទំនិញចែករំលែក',
        description:
          'ទំនិញ តម្លៃ និងភាពអាចរកបាន មកពីការគ្រប់គ្រងចំណូល និង Inventory។ វេប ការលក់តាមបញ្ជរ និងវិក្កយបត្រ នៅតែត្រូវគ្នា។',
      },
    ],
    meta: {
      title: 'AKAS Online Store | Ecommerce លើបញ្ជីទំនិញដូចគ្នានឹង ERP',
      description:
        'កំណត់ផ្ទាំងហាងអនឡាញ AKAS៖ ព័ត៌មានហាង វិធីទូទាត់ ផ្ទាំងបង្ហាញ លក្ខខណ្ឌ និងការកែសម្រួល ដោយលក់ទំនិញដូចគ្នានឹងការគ្រប់គ្រងចំណូល និង Inventory។',
      keywords: 'ecommerce, ហាងអនឡាញ, ហាង KHQR, AKAS storefront',
    },
    additionalFeatures: [
      {
        icon: '🚚',
        title: 'គោលនយោបាយដឹកជញ្ជូន',
        description: 'មាននៅពេលបើក ecommerce។',
      },
      {
        icon: '🖥️',
        title: 'Demo ផ្ទាល់',
        description: 'សាកល្បងហាងខាងមុខ និង store Admin ពីទំព័រ Demo របស់ AKAS។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'បញ្ជីទំនិញតែមួយ',
        description: 'មិនចាំបាច់ធ្វើសមកាលកម្មរវាង «ទំនិញគេហទំព័រ» និង «ទំនិញ ERP» ទេ។',
      },
      {
        number: '02',
        title: 'ការទូទាត់ដែលហិរញ្ញវត្ថុស្គាល់រួច',
        description: 'វិធីទូទាត់កំណត់ក្នុង ERP មិនត្រឹមតែសម្រាប់រូបរាងហាងទេ។',
      },
      {
        number: '03',
        title: 'យុទ្ធនាការដោយមិនសាងសង់ឡើងវិញ',
        description: 'ផ្ទាំងបង្ហាញ និងលក្ខខណ្ឌជាខ្លឹមសារ មិនមែនជាសំបុត្រអ្នកអភិវឌ្ឍន៍ទេ។',
      },
      {
        number: '04',
        title: 'ការបញ្ជាចូលវដ្តសម្រង់តម្លៃដល់សាច់ប្រាក់',
        description: 'ការលក់លើវេបស្ថិតជាមួយ ការលក់តាមបញ្ជរ និងវិក្កយបត្រក្នុងការគ្រប់គ្រងចំណូល។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
      { label: 'សាកល្បង Demo ហាង', to: '/demo' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើ Online Store', href: `${DOCS_ORIGIN}/en/online-store/` },
    ],
  },
  
];
